import React from "react";

interface IconProps {
   fill?: string;
   lighterFill?: string;
   stroke?: string;
   secondColor?: string;
   thirdColor?: string;
   className?: string;
   onClick?: React.MouseEventHandler;
   style?: React.CSSProperties;
   id?: string;
   width?: number | string;
   height?: number | string;
}

export const Icon_Info: React.FC<IconProps> = ({ fill = "#EF4444", className }) => {
   return (
      <svg
         width="20"
         height="20"
         viewBox="0 0 20 20"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20ZM10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM9 5H11V7H9V5ZM9 9H11V15H9V9Z"
            fill={fill}
         />
      </svg>
   );
};

export const Icon_MessageOpen: React.FC<IconProps> = ({ fill, className }) => {
   return (
      <svg
         width="12"
         height="12"
         viewBox="0 0 12 12"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.5001 4.98953C0.49998 4.99552 0.499968 5.00151 0.500063 5.00749V10C0.500063 10.3978 0.658097 10.7794 0.939398 11.0607C1.2207 11.342 1.60223 11.5 2.00005 11.5H9.99996C10.3978 11.5 10.7793 11.342 11.0606 11.0607C11.3419 10.7794 11.4999 10.3978 11.4999 10V5.00747C11.5 5.00161 11.5 4.99574 11.4999 4.98986C11.4967 4.51876 11.2713 4.08219 10.9025 3.80192L10.8999 3.8L6.89999 0.8C6.64035 0.605267 6.32455 0.5 6 0.5C5.67545 0.5 5.35965 0.605267 5.10001 0.8L1.10006 3.8C0.913764 3.93972 0.762561 4.1209 0.658421 4.32918C0.555841 4.53434 0.5017 4.76025 0.5001 4.98953ZM5.7 1.6C5.78655 1.53509 5.89182 1.5 6 1.5C6.10818 1.5 6.21345 1.53509 6.3 1.6L10.2974 4.59808L10.2985 4.5989C10.3579 4.6443 10.4056 4.70073 10.4396 4.76364L6.24953 7.42629L6.24842 7.42699C6.17388 7.4734 6.08782 7.49801 6 7.49801C5.91218 7.49801 5.82612 7.4734 5.75158 7.42699L1.55968 4.76321C1.59404 4.69931 1.64192 4.6436 1.70005 4.6L5.7 1.6ZM10.4999 5.91014V10C10.4999 10.1326 10.4473 10.2598 10.3535 10.3536C10.2597 10.4473 10.1326 10.5 9.99996 10.5H2.00005C1.86744 10.5 1.74026 10.4473 1.6465 10.3536C1.55273 10.2598 1.50005 10.1326 1.50005 10V5.91014L5.21685 8.27201L5.21955 8.27371C5.45348 8.42027 5.72395 8.49801 6 8.49801C6.27605 8.49801 6.54653 8.42027 6.78046 8.27371L6.78316 8.27201L10.4999 5.91014Z"
            fill={fill || "#808080"}
         />
      </svg>
   );
};

export const Icon_Messages: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="24"
         height="24"
         viewBox="0 0 24 24"
         fill={fill || "none"}
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M21 7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7M21 7V17C21 18.1046 20.1046 19 19 19H5C3.89543 19 3 18.1046 3 17V7M21 7L12 13L3 7"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </svg>
   );
};

export const Icon_Resize: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="23"
         height="23"
         viewBox="0 0 24 24"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M8 3V5H4V9H2V3H8ZM2 21V15H4V19H8V21H2ZM22 21H16V19H20V15H22V21ZM22 9H20V5H16V3H22V9Z"
            fill={fill}
            stroke={stroke}
         />
      </svg>
   );
};

export const Icon_Close: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="24"
         height="24"
         viewBox="0 0 24 24"
         fill={fill}
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <g clipPath="url(#clip0_1204_22539)">
            <path
               d="M18 6L6 18"
               stroke={stroke}
               strokeWidth="1.5"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M6 6L18 18"
               stroke={stroke}
               strokeWidth="1.5"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
         </g>
         <defs>
            <clipPath id="clip0_1204_22539">
               <rect width="24" height="24" fill="white" />
            </clipPath>
         </defs>
      </svg>
   );
};

export const Icon_Download: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="16"
         height="16"
         viewBox="0 0 16 16"
         fill={fill}
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <g clipPath="url(#clip0_1204_22723)">
            <path
               d="M2.66663 11.3335V12.6668C2.66663 13.0205 2.8071 13.3596 3.05715 13.6096C3.3072 13.8597 3.64634 14.0002 3.99996 14.0002H12C12.3536 14.0002 12.6927 13.8597 12.9428 13.6096C13.1928 13.3596 13.3333 13.0205 13.3333 12.6668V11.3335"
               stroke={stroke}
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M4.66663 7.3335L7.99996 10.6668L11.3333 7.3335"
               stroke={stroke}
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M8 2.6665V10.6665"
               stroke={stroke}
               strokeLinecap="round"
               strokeLinejoin="round"
            />
         </g>
         <defs>
            <clipPath id="clip0_1204_22723">
               <rect width="16" height="16" fill="white" />
            </clipPath>
         </defs>
      </svg>
   );
};

export const Icon_Google: React.FC<IconProps> = ({ fill, stroke, className, onClick }) => {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         x="0px"
         y="0px"
         width="20"
         height="20"
         viewBox="0 0 48 48"
      >
         <path
            fill="#FFC107"
            d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
         ></path>
         <path
            fill="#FF3D00"
            d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
         ></path>
         <path
            fill="#4CAF50"
            d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
         ></path>
         <path
            fill="#1976D2"
            d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
         ></path>
      </svg>
   );
};

export const Icon_Trash: React.FC<IconProps> = ({ fill, stroke, className, onClick, style }) => {
   return (
      <svg
         width="20"
         height="20"
         viewBox="0 0 20 20"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
         onClick={onClick}
         style={style}
      >
         <path
            d="M15 4H20V6H18V19C18 19.5523 17.5523 20 17 20H3C2.44772 20 2 19.5523 2 19V6H0V4H5V1C5 0.44772 5.44772 0 6 0H14C14.5523 0 15 0.44772 15 1V4ZM16 6H4V18H16V6ZM7 9H9V15H7V9ZM11 9H13V15H11V9ZM7 2V4H13V2H7Z"
            fill={fill}
            stroke={stroke}
         />
      </svg>
   );
};

export const Icon_Clip: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="24"
         height="24"
         viewBox="0 0 24 24"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M14.8287 7.7574L9.1718 13.4143C8.78127 13.8048 8.78127 14.4379 9.1718 14.8285C9.56232 15.219 10.1955 15.219 10.586 14.8285L16.2429 9.17161C17.4144 8.00004 17.4144 6.10055 16.2429 4.92897C15.0713 3.7574 13.1718 3.7574 12.0002 4.92897L6.34337 10.5858C4.39075 12.5384 4.39075 15.7043 6.34337 17.6569C8.29599 19.6095 11.4618 19.6095 13.4144 17.6569L19.0713 12L20.4855 13.4143L14.8287 19.0711C12.095 21.8048 7.66283 21.8048 4.92916 19.0711C2.19549 16.3374 2.19549 11.9053 4.92916 9.17161L10.586 3.51476C12.5386 1.56214 15.7045 1.56214 17.6571 3.51476C19.6097 5.46738 19.6097 8.63321 17.6571 10.5858L12.0002 16.2427C10.8287 17.4143 8.92916 17.4143 7.75759 16.2427C6.58601 15.0711 6.58601 13.1716 7.75759 12L13.4144 6.34319L14.8287 7.7574Z"
            fill={fill}
            stroke={stroke}
         />
      </svg>
   );
};

export const Icon_NewMessage: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="18"
         height="19"
         viewBox="0 0 18 19"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M2.25 2.75H15.75C16.1642 2.75 16.5 3.08579 16.5 3.5V15.5C16.5 15.9142 16.1642 16.25 15.75 16.25H2.25C1.83579 16.25 1.5 15.9142 1.5 15.5V3.5C1.5 3.08579 1.83579 2.75 2.25 2.75ZM9.04545 9.26218L4.23542 5.17827L3.26458 6.32173L9.05483 11.2378L14.7408 6.31712L13.7592 5.18288L9.04545 9.26218Z"
            fill={fill}
            stroke={stroke}
         />
      </svg>
   );
};

export const Icon_Search: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="16"
         height="16"
         viewBox="0 0 17 17"
         fill={fill}
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M7.83333 13.1667C10.7789 13.1667 13.1667 10.7789 13.1667 7.83333C13.1667 4.88781 10.7789 2.5 7.83333 2.5C4.88781 2.5 2.5 4.88781 2.5 7.83333C2.5 10.7789 4.88781 13.1667 7.83333 13.1667Z"
            stroke={stroke}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M14.5001 14.5001L11.6001 11.6001"
            stroke={stroke}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </svg>
   );
};

export const Icon_Chat: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="16"
         height="16"
         viewBox="0 0 16 16"
         fill={fill}
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <g clipPath="url(#clip0_1329_11600)">
            <path
               d="M13.9998 9.33333L11.9998 7.33333H7.33317C7.15636 7.33333 6.98679 7.2631 6.86177 7.13807C6.73674 7.01305 6.6665 6.84348 6.6665 6.66667V2.66667C6.6665 2.48986 6.73674 2.32029 6.86177 2.19526C6.98679 2.07024 7.15636 2 7.33317 2H13.3332C13.51 2 13.6796 2.07024 13.8046 2.19526C13.9296 2.32029 13.9998 2.48986 13.9998 2.66667V9.33333Z"
               stroke={stroke}
               strokeWidth="1.5"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M9.33333 9.99984V11.3332C9.33333 11.51 9.2631 11.6796 9.13807 11.8046C9.01305 11.9296 8.84348 11.9998 8.66667 11.9998H4L2 13.9998V7.33317C2 7.15636 2.07024 6.98679 2.19526 6.86177C2.32029 6.73674 2.48986 6.6665 2.66667 6.6665H4"
               stroke={stroke}
               strokeWidth="1.5"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
         </g>
         <defs>
            <clipPath id="clip0_1329_11600">
               <rect width="16" height="16" fill="white" />
            </clipPath>
         </defs>
      </svg>
   );
};

export const Icon_Cases: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="22"
         height="12"
         viewBox="0 0 22 12"
         fill={fill}
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M6 6L11 11L21 1M1 6L6 11M11 6L16 1"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </svg>
   );
};

export const Icon_Planner: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="24"
         height="24"
         viewBox="0 0 24 24"
         fill={fill}
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M4 4H10M14 4H20M6 8H8C9.10457 8 10 8.89543 10 10V18C10 19.1046 9.10457 20 8 20H6C4.89543 20 4 19.1046 4 18V10C4 8.89543 4.89543 8 6 8ZM16 8H18C19.1046 8 20 8.89543 20 10V12C20 13.1046 19.1046 14 18 14H16C14.8954 14 14 13.1046 14 12V10C14 8.89543 14.8954 8 16 8Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </svg>
   );
};

export const Icon_LogOut: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="24"
         height="24"
         viewBox="0 0 24 24"
         fill={fill}
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M13 12V12.01M3 21H21M5 21V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H14.5M17 13.5V21M14 7H21M21 7L18 4M21 7L18 10"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </svg>
   );
};

export const Icon_ArrowBar: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="12"
         height="14"
         viewBox="0 0 12 14"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M6.9142 7.0001L11.7071 2.20718L10.2929 0.792969L4.0858 7.0001L10.2929 13.2072L11.7071 11.793L6.9142 7.0001ZM0 13.0001V1.00008H2V13.0001H0Z"
            fill={fill}
            stroke={stroke}
         />
      </svg>
   );
};

export const Icon_DoubleLeftCurvyArrow: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="13"
         height="11"
         viewBox="0 0 13 11"
         fill={fill}
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M11.6665 10.0002V6.00016C11.6665 5.46973 11.4558 4.96102 11.0807 4.58595C10.7056 4.21088 10.1969 4.00016 9.6665 4.00016H4.99984M4.99984 4.00016L7.6665 6.66683M4.99984 4.00016L7.6665 1.3335M4.33317 6.66683L1.6665 4.00016L4.33317 1.3335"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </svg>
   );
};

export const Icon_LeftCurvyArrow: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="11"
         height="11"
         viewBox="0 0 11 11"
         fill={fill}
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M10.0002 10.0002V6.00016C10.0002 5.46973 9.78945 4.96102 9.41438 4.58595C9.0393 4.21088 8.5306 4.00016 8.00016 4.00016H1.3335M1.3335 4.00016L4.00016 1.3335M1.3335 4.00016L4.00016 6.66683"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </svg>
   );
};

export const Icon_RightCurvyArrow: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="11"
         height="11"
         viewBox="0 0 11 11"
         fill={fill}
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M1 10.0002V6.00016C1 5.46973 1.21071 4.96102 1.58579 4.58595C1.96086 4.21088 2.46957 4.00016 3 4.00016H9.66667M9.66667 4.00016L7 1.3335M9.66667 4.00016L7 6.66683"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </svg>
   );
};

export const Icon_Link: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="16"
         height="17"
         viewBox="0 0 16 17"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M8.70667 5.90732L9.64947 6.85012C11.4719 8.67256 11.4719 11.6274 9.64947 13.4498L9.41374 13.6855C7.59134 15.508 4.63655 15.508 2.8141 13.6855C0.991654 11.863 0.991654 8.9083 2.8141 7.08582L3.75691 8.02863C2.45516 9.33036 2.45516 11.441 3.75691 12.7427C5.05865 14.0444 7.16921 14.0444 8.47094 12.7427L8.70667 12.507C10.0084 11.2052 10.0084 9.0947 8.70667 7.79296L7.76387 6.85012L8.70667 5.90732ZM13.185 9.91423L12.2422 8.97143C13.5439 7.6697 13.5439 5.55914 12.2422 4.2574C10.9405 2.95565 8.82987 2.95565 7.52814 4.2574L7.29247 4.4931C5.99069 5.79485 5.99069 7.90543 7.29247 9.20716L8.23527 10.15L7.29247 11.0928L6.34963 10.15C4.52719 8.3275 4.52719 5.37274 6.34963 3.55029L6.58533 3.31459C8.40781 1.49214 11.3625 1.49214 13.185 3.31459C15.0075 5.13704 15.0075 8.09183 13.185 9.91423Z"
            fill={fill}
            stroke={stroke}
         />
      </svg>
   );
};

export const Icon_Calendar: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="16"
         height="16"
         viewBox="0 0 16 16"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M6.00065 0.666504V1.99984H10.0007V0.666504H11.334V1.99984H14.0007C14.3689 1.99984 14.6673 2.29832 14.6673 2.6665V13.3332C14.6673 13.7014 14.3689 13.9998 14.0007 13.9998H2.00065C1.63246 13.9998 1.33398 13.7014 1.33398 13.3332V2.6665C1.33398 2.29832 1.63246 1.99984 2.00065 1.99984H4.66732V0.666504H6.00065ZM13.334 7.33317H2.66732V12.6665H13.334V7.33317ZM7.33398 8.6665V11.3332H4.00065V8.6665H7.33398ZM4.66732 3.33317H2.66732V5.99984H13.334V3.33317H11.334V4.6665H10.0007V3.33317H6.00065V4.6665H4.66732V3.33317Z"
            fill={fill}
            stroke={stroke}
         />
      </svg>
   );
};

export const Icon_Planned: React.FC<IconProps> = ({
   fill,
   stroke,
   className,
   width = "10",
   height = "11",
}) => {
   return (
      <svg
         width={width}
         height={height}
         viewBox="0 0 10 11"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M3.5 0.5V1.5H6.5V0.5H7.5V1.5H9.5C9.77615 1.5 10 1.72386 10 2V10C10 10.2761 9.77615 10.5 9.5 10.5H0.5C0.22386 10.5 0 10.2761 0 10V2C0 1.72386 0.22386 1.5 0.5 1.5H2.5V0.5H3.5ZM9 5.5H1V9.5H9V5.5ZM2.5 2.5H1V4.5H9V2.5H7.5V3.5H6.5V2.5H3.5V3.5H2.5V2.5Z"
            fill={fill}
            stroke={stroke}
         />
      </svg>
   );
};

export const Icon_MailCheck: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="15"
         height="13"
         viewBox="0 0 15 13"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M13.6673 6.89427C13.2503 6.74687 12.8015 6.66667 12.334 6.66667C10.1249 6.66667 8.33398 8.45753 8.33398 10.6667C8.33398 11.1342 8.41418 11.5829 8.56158 12H1.00065C0.632464 12 0.333984 11.7015 0.333984 11.3333V0.666667C0.333984 0.29848 0.632464 0 1.00065 0H13.0007C13.3689 0 13.6673 0.29848 13.6673 0.666667V6.89427ZM7.04105 5.7886L2.76546 2.15847L1.9025 3.17487L7.04938 7.54473L12.1036 3.17077L11.2311 2.16256L7.04105 5.7886ZM11.6673 12.6667L9.31032 10.3097L10.2531 9.36687L11.6673 10.7811L14.0243 8.424L14.9671 9.36687L11.6673 12.6667Z"
            fill={fill}
            stroke={stroke}
         />
      </svg>
   );
};

export const Icon_CasePlan: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="24"
         height="24"
         viewBox="0 0 24 24"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M7.5 3V1.5H8.5V3V3.5H9H15H15.5V3V1.5H16.5V3V3.5H17H21C21.2762 3.5 21.5 3.72386 21.5 4V20C21.5 20.2762 21.2762 20.5 21 20.5H3C2.72386 20.5 2.5 20.2762 2.5 20V4C2.5 3.72386 2.72386 3.5 3 3.5H7H7.5V3ZM20.5 8V7.5H20H4H3.5V8V19V19.5H4H20H20.5V19V8ZM15.7426 11.5503L11.5 15.7929L8.67158 12.9645L9.37868 12.2574L11.1464 14.0252L11.5 14.3787L11.8536 14.0251L15.0355 10.8431L15.7426 11.5503Z"
            fill={fill}
            stroke={stroke}
         />
      </svg>
   );
};

export const Icon_QuestionMarkCircle: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="20"
         height="21"
         viewBox="0 0 20 21"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M10 20.5C4.47715 20.5 0 16.0228 0 10.5C0 4.97715 4.47715 0.5 10 0.5C15.5228 0.5 20 4.97715 20 10.5C20 16.0228 15.5228 20.5 10 20.5ZM10 18.5C14.4183 18.5 18 14.9183 18 10.5C18 6.08172 14.4183 2.5 10 2.5C5.58172 2.5 2 6.08172 2 10.5C2 14.9183 5.58172 18.5 10 18.5ZM9 13.5H11V15.5H9V13.5ZM11 11.8551V12.5H9V11C9 10.4477 9.4477 10 10 10C10.8284 10 11.5 9.3284 11.5 8.5C11.5 7.67157 10.8284 7 10 7C9.2723 7 8.6656 7.51823 8.5288 8.20577L6.56731 7.81346C6.88637 6.20919 8.302 5 10 5C11.933 5 13.5 6.567 13.5 8.5C13.5 10.0855 12.4457 11.4248 11 11.8551Z"
            fill={fill}
            stroke={stroke}
         />
      </svg>
   );
};

export const Icon_Padlock: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="9"
         height="10"
         viewBox="0 0 9 10"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M7.5 5H8.5V10H0.5V5H1.5V3C1.5 1.159 2.8431 0 4.5 0C6.1569 0 7.5 1.159 7.5 3V5ZM5.5 5V3C5.5 2.38633 5.0523 2 4.5 2C3.9477 2 3.5 2.38633 3.5 3V5H5.5Z"
            fill={fill}
            stroke={stroke}
         />
      </svg>
   );
};

export const Icon_Sent: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="21"
         height="21"
         viewBox="0 0 21 21"
         fill={fill}
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M8.99995 12L19.9999 1M8.99995 12L12.4999 19C12.5438 19.0957 12.6143 19.1769 12.7029 19.2338C12.7915 19.2906 12.8946 19.3209 12.9999 19.3209C13.1053 19.3209 13.2084 19.2906 13.297 19.2338C13.3856 19.1769 13.4561 19.0957 13.4999 19L19.9999 1M8.99995 12L1.99995 8.5C1.90421 8.45613 1.82307 8.38569 1.76619 8.29705C1.70931 8.20842 1.67908 8.10532 1.67908 8C1.67908 7.89468 1.70931 7.79158 1.76619 7.70295C1.82307 7.61431 1.90421 7.54387 1.99995 7.5L19.9999 1"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </svg>
   );
};

export const Icon_SquareRightArrow: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="24"
         height="24"
         viewBox="0 0 24 24"
         fill={fill}
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <g clipPath="url(#clip0_1_3338)">
            <path
               d="M7 12H21"
               stroke={stroke}
               strokeWidth="1.5"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M18 15L21 12L18 9"
               stroke={stroke}
               strokeWidth="1.5"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M3 10H7V14H3V10Z"
               stroke={stroke}
               strokeWidth="1.5"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
         </g>
         <defs>
            <clipPath id="clip0_1_3338">
               <rect width="24" height="24" fill="white" />
            </clipPath>
         </defs>
      </svg>
   );
};

export const Icon_ArrowResize: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="18"
         height="18"
         viewBox="0 0 18 18"
         fill={fill}
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M0.75 0.75V5.25M0.75 0.75H5.25M0.75 0.75L6 6M0.75 17.25V12.75M0.75 17.25H5.25M0.75 17.25L6 12M17.25 0.75H12.75M17.25 0.75V5.25M17.25 0.75L12 6M17.25 17.25H12.75M17.25 17.25V12.75M17.25 17.25L12 12"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </svg>
   );
};

export const Icon_Check: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="17"
         height="12"
         viewBox="0 0 17 12"
         fill={fill}
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M1 6L6 11L16 1"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </svg>
   );
};

export const Icon_Settings: React.FC<IconProps> = ({ fill, stroke, className, onClick }) => {
   return (
      <svg
         width="1.2em"
         height="1.2em"
         viewBox="0 0 24 24"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
         onClick={onClick}
      >
         <g clipPath="url(#clip0_1410_13228)">
            <path
               d="M10.325 4.317C10.751 2.561 13.249 2.561 13.675 4.317C13.7389 4.5808 13.8642 4.82578 14.0407 5.032C14.2172 5.23822 14.4399 5.39985 14.6907 5.50375C14.9414 5.60764 15.2132 5.65085 15.4838 5.62987C15.7544 5.60889 16.0162 5.5243 16.248 5.383C17.791 4.443 19.558 6.209 18.618 7.753C18.4769 7.98466 18.3924 8.24634 18.3715 8.51677C18.3506 8.78721 18.3938 9.05877 18.4975 9.30938C18.6013 9.55999 18.7627 9.78258 18.9687 9.95905C19.1747 10.1355 19.4194 10.2609 19.683 10.325C21.439 10.751 21.439 13.249 19.683 13.675C19.4192 13.7389 19.1742 13.8642 18.968 14.0407C18.7618 14.2172 18.6001 14.4399 18.4963 14.6907C18.3924 14.9414 18.3491 15.2132 18.3701 15.4838C18.3911 15.7544 18.4757 16.0162 18.617 16.248C19.557 17.791 17.791 19.558 16.247 18.618C16.0153 18.4769 15.7537 18.3924 15.4832 18.3715C15.2128 18.3506 14.9412 18.3938 14.6906 18.4975C14.44 18.6013 14.2174 18.7627 14.0409 18.9687C13.8645 19.1747 13.7391 19.4194 13.675 19.683C13.249 21.439 10.751 21.439 10.325 19.683C10.2611 19.4192 10.1358 19.1742 9.95929 18.968C9.7828 18.7618 9.56011 18.6001 9.30935 18.4963C9.05859 18.3924 8.78683 18.3491 8.51621 18.3701C8.24559 18.3911 7.98375 18.4757 7.752 18.617C6.209 19.557 4.442 17.791 5.382 16.247C5.5231 16.0153 5.60755 15.7537 5.62848 15.4832C5.64942 15.2128 5.60624 14.9412 5.50247 14.6906C5.3987 14.44 5.23726 14.2174 5.03127 14.0409C4.82529 13.8645 4.58056 13.7391 4.317 13.675C2.561 13.249 2.561 10.751 4.317 10.325C4.5808 10.2611 4.82578 10.1358 5.032 9.95929C5.23822 9.7828 5.39985 9.56011 5.50375 9.30935C5.60764 9.05859 5.65085 8.78683 5.62987 8.51621C5.60889 8.24559 5.5243 7.98375 5.383 7.752C4.443 6.209 6.209 4.442 7.753 5.382C8.753 5.99 10.049 5.452 10.325 4.317Z"
               stroke={stroke}
               fill={fill}
               strokeWidth="1.5"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
               stroke={stroke}
               fill={fill}
               strokeWidth="1.5"
               strokeLinecap="round"
               strokeLinejoin="round"
            />
         </g>
         <defs>
            <clipPath id="clip0_1410_13228">
               <rect width="24" height="24" fill="white" />
            </clipPath>
         </defs>
      </svg>
   );
};

export const Icon_ChevronLeft: React.FC<IconProps> = ({
   fill,
   stroke,
   className,
   onClick = undefined,
}) => {
   return (
      <svg
         width="1em"
         height="1em"
         viewBox="0 0 8 14"
         fill={fill}
         xmlns="http://www.w3.org/2000/svg"
         className={className}
         onClick={onClick}
      >
         <path
            d="M7 1L1 7L7 13"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </svg>
   );
};

export const Icon_ChevronRight: React.FC<IconProps> = ({
   fill,
   stroke,
   className,
   onClick = undefined,
}) => {
   return (
      <svg
         width="1em"
         height="1em"
         viewBox="0 0 8 14"
         fill={fill}
         xmlns="http://www.w3.org/2000/svg"
         className={className}
         onClick={onClick}
      >
         <path
            d="M1 1L7 7L1 13"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </svg>
   );
};

export const Icon_AttachPinOutline: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="13"
         height="13"
         viewBox="0 0 13 13"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M7.21828 0.126465L12.8752 5.78331L11.9324 6.7261L11.461 6.2547L8.63248 9.08317L8.16108 11.4402L7.21828 12.383L4.38986 9.55457L1.09003 12.8544L0.147217 11.9116L3.44705 8.61177L0.618623 5.78331L1.56143 4.84051L3.91846 4.3691L6.74688 1.54068L6.27548 1.06928L7.21828 0.126465ZM7.68968 2.48349L4.5758 5.59738L2.69455 5.97364L7.02795 10.307L7.40422 8.42577L10.5182 5.31192L7.68968 2.48349Z"
            fill={fill}
            stroke={stroke}
         />
      </svg>
   );
};

export const Icon_AttachPinSolid: React.FC<IconProps> = ({ fill, stroke, className, onClick }) => {
   return (
      <svg
         width="13"
         height="13"
         viewBox="0 0 13 13"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
         onClick={onClick}
      >
         <path
            d="M12.8752 5.78331L11.9324 6.7261L11.461 6.2547L8.63248 9.08317L8.16108 11.4402L7.21828 12.383L4.38986 9.55457L1.09003 12.8544L0.147217 11.9116L3.44705 8.61177L0.618623 5.78331L1.56143 4.84051L3.91846 4.3691L6.74688 1.54068L6.27548 1.06928L7.21828 0.126465L12.8752 5.78331Z"
            fill={fill}
            stroke={stroke}
         />
      </svg>
   );
};

export const Icon_AttachPinCrossed: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="13"
         height="13"
         viewBox="0 0 13 13"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M11.9801 10.4475L11.0373 11.3904L8.68093 9.03404L8.63173 9.08317L8.16033 11.4402L7.21753 12.383L4.38912 9.55457L1.08929 12.8544L0.146484 11.9116L3.44631 8.61177L0.617884 5.78331L1.5607 4.84051L3.91772 4.3691L3.96686 4.31996L1.60915 1.96225L2.55196 1.01944L11.9801 10.4475ZM4.90966 5.26277L4.57507 5.59738L2.69381 5.97364L7.02727 10.307L7.40346 8.42577L7.73806 8.09117L4.90966 5.26277ZM10.5174 5.31192L9.62373 6.20557L10.5665 7.14837L11.4602 6.2547L11.9316 6.7261L12.8744 5.78331L7.21753 0.126465L6.27473 1.06928L6.74613 1.54068L5.85246 2.43435L6.79526 3.37715L7.68893 2.48349L10.5174 5.31192Z"
            fill={fill}
            stroke={stroke}
         />
      </svg>
   );
};

export const Icon_CloseCircle: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="17"
         height="17"
         viewBox="0 0 14 14"
         fill={fill}
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M5.5 5.5L8.5 8.5M8.5 5.5L5.5 8.5M13 7C13 7.78793 12.8448 8.56815 12.5433 9.2961C12.2417 10.0241 11.7998 10.6855 11.2426 11.2426C10.6855 11.7998 10.0241 12.2417 9.2961 12.5433C8.56815 12.8448 7.78793 13 7 13C6.21207 13 5.43185 12.8448 4.7039 12.5433C3.97595 12.2417 3.31451 11.7998 2.75736 11.2426C2.20021 10.6855 1.75825 10.0241 1.45672 9.2961C1.15519 8.56815 1 7.78793 1 7C1 5.4087 1.63214 3.88258 2.75736 2.75736C3.88258 1.63214 5.4087 1 7 1C8.5913 1 10.1174 1.63214 11.2426 2.75736C12.3679 3.88258 13 5.4087 13 7Z"
            stroke={stroke}
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </svg>
   );
};

export const Icon_SearchCircle: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="17"
         height="17"
         viewBox="0 0 16 16"
         fill={fill}
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <g clipPath="url(#clip0_1438_6857)">
            <path
               d="M5.70668 2.45996C4.97873 2.76129 4.31726 3.20302 3.76001 3.75996"
               stroke={stroke}
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M2.46 5.70654C2.1577 6.43341 2.0014 7.21266 2 7.99988"
               stroke={stroke}
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M2.45996 10.2935C2.76129 11.0214 3.20302 11.6829 3.75996 12.2401"
               stroke={stroke}
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M5.70679 13.54C6.43365 13.8423 7.2129 13.9986 8.00012 14"
               stroke={stroke}
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M10.2932 13.5402C11.0212 13.2389 11.6826 12.7972 12.2399 12.2402"
               stroke={stroke}
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M13.54 10.2933C13.8423 9.56647 13.9986 8.78722 14 8"
               stroke={stroke}
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M13.54 5.70643C13.2387 4.97849 12.7969 4.31701 12.24 3.75977"
               stroke={stroke}
               strokeLinecap="round"
               strokeLinejoin="round"
            />
            <path
               d="M10.2933 2.46C9.56647 2.1577 8.78722 2.0014 8 2"
               stroke={stroke}
               strokeLinecap="round"
               strokeLinejoin="round"
            />
         </g>
         <defs>
            <clipPath id="clip0_1438_6857">
               <rect width="17" height="17" fill="white" />
            </clipPath>
         </defs>
      </svg>
   );
};

export const Icon_MailCheckOutline: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="15"
         height="13"
         viewBox="0 0 15 13"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M13.6666 7.33333H12.3333V2.82528L7.04779 7.55867L1.66659 2.81063V10.6667H8.33325V12H0.999919C0.631732 12 0.333252 11.7015 0.333252 11.3333V0.666667C0.333252 0.29848 0.631732 0 0.999919 0H12.9999C13.3681 0 13.6666 0.29848 13.6666 0.666667V7.33333ZM2.00756 1.33333L7.04119 5.77467L12.0006 1.33333H2.00756ZM11.6666 12.6667L9.30959 10.3097L10.2524 9.36687L11.6666 10.7811L14.0236 8.424L14.9664 9.36687L11.6666 12.6667Z"
            fill={fill}
            stroke={stroke}
         />
      </svg>
   );
};

export const Icon_RedirectToCase: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="18"
         height="18"
         viewBox="0 0 18 18"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M7 0V2H2V16H16V11H18V17C18 17.5523 17.5523 18 17 18H1C0.44772 18 0 17.5523 0 17V1C0 0.44772 0.44772 0 1 0H7ZM14.5858 2H10V0H18V8H16V3.41421L9 10.4142L7.5858 9L14.5858 2Z"
            fill={fill}
            stroke={stroke}
         />
      </svg>
   );
};

export const Icon_MessagesWithСheckMark: React.FC<IconProps> = ({
   fill,
   stroke,
   secondColor,
   className,
}) => {
   return (
      <svg
         width="72"
         height="72"
         viewBox="0 0 72 72"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path d="M5.49998 27.4996L35.7385 38.3747L57.1598 13.9999" fill={stroke} />
         <path
            d="M5.49998 27.4996L35.7385 38.3747L57.1598 13.9999L53 10L30.4999 16.4999L7.99993 21.9998L5.49998 27.4996Z"
            fill={stroke}
         />
         <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.93609 24.6958C8.53282 23.6623 9.51571 22.9081 10.6685 22.5992L51.2374 11.7288C52.3902 11.4199 53.6185 11.5816 54.6521 12.1783C55.4637 12.6469 56.103 13.3536 56.4897 14.1936L36.3098 37.156L7.35228 27.36C7.26717 26.4391 7.46751 25.5074 7.93609 24.6958ZM4.59407 28.9068L12.3533 57.8648C12.8682 59.7861 14.1251 61.4242 15.8478 62.4188C17.5704 63.4134 19.6176 63.6829 21.5389 63.1681L38.9256 58.5093C39.7258 58.2949 40.2007 57.4724 39.9862 56.6722C39.7718 55.872 38.9493 55.3971 38.1491 55.6115L20.7625 60.2703C19.6097 60.5792 18.3814 60.4175 17.3478 59.8207C16.3142 59.224 15.56 58.2411 15.2511 57.0883L8.21195 30.8178L36.2957 40.3182C36.8693 40.5122 37.5034 40.3424 37.9031 39.8875L57.4742 17.618L61.4075 32.2974C61.6219 33.0976 62.4444 33.5725 63.2446 33.3581C64.0448 33.1437 64.5197 32.3212 64.3053 31.521L59.6518 14.1541C59.648 14.139 59.644 14.124 59.6397 14.1091C59.1207 12.1986 57.8672 10.5705 56.1521 9.58025C54.4295 8.58569 52.3823 8.31617 50.4609 8.83099L9.89206 19.7014C7.97071 20.2162 6.33257 21.4732 5.33801 23.1958C4.34782 24.9109 4.07632 26.9477 4.58202 28.8617C4.5858 28.8768 4.58982 28.8918 4.59407 28.9068Z"
            fill={stroke}
         />
         <path
            d="M50.1286 53.9547L57.4771 58.1974L65.9623 43.5004"
            stroke={secondColor}
            strokeWidth="6"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </svg>
   );
};

export const Icon_CalendarWithСheckMark: React.FC<IconProps> = ({
   fill,
   stroke,
   secondColor,
   className,
}) => {
   return (
      <svg
         width="72"
         height="72"
         viewBox="0 0 72 72"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <g clip-path="url(#clip0_1530_24633)">
            <g clip-path="url(#clip1_1530_24633)">
               <path
                  d="M41.5392 62.4678L25.6014 66.7383C24.0644 67.1501 22.4266 66.9345 21.0485 66.1389C19.6704 65.3432 18.6648 64.0327 18.253 62.4956L8.93548 27.7223C8.52362 26.1852 8.73924 24.5475 9.53488 23.1694C10.3305 21.7913 11.641 20.7857 13.1781 20.3738L47.9515 11.0564C49.4885 10.6445 51.1263 10.8601 52.5044 11.6558C53.8825 12.4514 54.8881 13.7619 55.2999 15.299L59.9587 32.6857"
                  fill="none"
                  stroke={stroke}
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M12.0413 39.3134L58.4057 26.89L54.5 13.9994L52 11.5L48.5 10.9994L12.0413 21.5L10 23L8.99999 25.4999L12.0413 39.3134Z"
                  fill={secondColor}
                  stroke={stroke}
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M40.603 6.81348L43.7089 18.4046"
                  stroke={stroke}
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M17.4207 13.0254L20.5265 24.6165"
                  stroke={stroke}
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M50.1286 50.9547L57.4771 55.1974L65.9623 40.5004"
                  stroke={secondColor}
                  strokeWidth="6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
            </g>
         </g>
         <defs>
            <clipPath id="clip0_1530_24633">
               <rect width="72" height="72" fill="white" />
            </clipPath>
            <clipPath id="clip1_1530_24633">
               <rect
                  width="72"
                  height="72"
                  fill="white"
                  transform="translate(-8.09082 10.5439) rotate(-15)"
               />
            </clipPath>
         </defs>
      </svg>
   );
};

export const Icon_CasesWithBackground: React.FC<IconProps> = ({
   fill,
   stroke,
   secondColor,
   thirdColor,
   className,
}) => {
   return (
      <svg
         width="72"
         height="72"
         viewBox="0 0 72 72"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M21.4694 8.79883L51.1165 8.79883C57.8414 8.79883 63.293 14.2504 63.293 20.9753V50.6224C63.293 57.3472 57.8414 62.7988 51.1165 62.7988H21.4694C14.7446 62.7988 9.29297 57.3472 9.29297 50.6224L9.29297 20.9753C9.29297 14.2504 14.7446 8.79883 21.4694 8.79883Z"
            fill={stroke}
            stroke={stroke}
            strokeWidth="2"
         />
         <path
            d="M34.2418 39.8011L37.2354 42.6391L53.6758 27.0534C54.5021 26.27 55.8468 26.27 56.6731 27.0534C57.4995 27.8367 57.4995 29.1115 56.6731 29.8949L38.7754 46.8623C37.9265 47.667 36.548 47.667 35.6954 46.8623L25.246 36.956C24.4196 36.1726 24.4196 34.8979 25.246 34.1145C26.0723 33.3311 27.417 33.3311 28.2433 34.1145L31.2482 36.9632L34.2418 39.8011Z"
            fill={secondColor}
         />
         <path
            d="M33.9597 34.8122L43.952 24.82C44.8695 23.9025 46.3541 23.9025 47.2716 24.82C48.1891 25.7374 48.1891 27.2221 47.2716 28.1396L37.2793 38.1318L33.9597 34.8122Z"
            fill={thirdColor}
         />
         <path
            d="M28.7208 46.8586C27.9152 47.6669 26.607 47.6669 25.7979 46.8586L15.8811 36.909C15.0969 36.1221 15.0969 34.8418 15.8811 34.055C16.6653 33.2681 17.9415 33.2681 18.7257 34.055L20.1444 35.4784L28.7208 44.0833C29.4837 44.8487 29.4837 46.0897 28.7208 46.8551V46.8586Z"
            fill={secondColor}
         />
      </svg>
   );
};

export const Icon_CalendarWithGear: React.FC<IconProps> = ({
   fill,
   stroke,
   secondColor,
   className,
}) => {
   return (
      <svg
         width="72"
         height="72"
         viewBox="0 0 72 72"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <g clip-path="url(#clip0_1530_24812)">
            <g clip-path="url(#clip1_1530_24812)">
               <path
                  d="M34.5 63H18C16.4087 63 14.8826 62.3679 13.7574 61.2426C12.6321 60.1174 12 58.5913 12 57L12 21C12 19.4087 12.6321 17.8826 13.7574 16.7574C14.8826 15.6321 16.4087 15 18 15L54 15C55.5913 15 57.1174 15.6321 58.2426 16.7574C59.3679 17.8826 60 19.4087 60 21V39"
                  stroke={stroke}
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M12 32.9999H60L59.5637 19.5376L57.7958 16.4763L54.5446 15.0869L16.6105 15.7935L14.2505 16.7141L12.6376 18.87L12 32.9999Z"
                  fill={secondColor}
                  stroke={stroke}
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M48 9V21"
                  stroke={stroke}
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M24 9V21"
                  stroke={stroke}
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M53.3819 49.6048C53.4272 49.3782 53.5496 49.1742 53.7283 49.0277C53.9069 48.8811 54.1308 48.8009 54.3619 48.8008H56.7219C56.953 48.8009 57.1769 48.8811 57.3556 49.0277C57.5343 49.1742 57.6566 49.3782 57.7019 49.6048L58.0329 51.2568C58.7314 51.523 59.3827 51.8994 59.9619 52.3718L61.5599 51.8318C61.7788 51.7578 62.0166 51.7619 62.2328 51.8434C62.449 51.9249 62.6303 52.0787 62.7459 52.2788L63.9259 54.3228C64.0416 54.5229 64.0844 54.7568 64.047 54.9849C64.0096 55.213 63.8944 55.4211 63.7209 55.5738L62.4539 56.6868C62.5721 57.4247 62.5721 58.1768 62.4539 58.9148L63.7209 60.0278C63.8943 60.1803 64.0096 60.3881 64.0471 60.616C64.0847 60.8439 64.0422 61.0777 63.9269 61.2778L62.7469 63.3228C62.6313 63.5231 62.4498 63.677 62.2334 63.7585C62.0169 63.8401 61.779 63.844 61.5599 63.7698L59.9619 63.2298C59.3827 63.7022 58.7314 64.0786 58.0329 64.3448L57.7029 65.9968C57.6576 66.2234 57.5353 66.4273 57.3566 66.5739C57.1779 66.7205 56.954 66.8006 56.7229 66.8008H54.3619C54.1308 66.8006 53.9069 66.7205 53.7283 66.5739C53.5496 66.4273 53.4272 66.2234 53.3819 65.9968L53.0509 64.3448C52.3525 64.0786 51.7012 63.7022 51.1219 63.2298L49.5239 63.7698C49.305 63.8438 49.0673 63.8397 48.8511 63.7582C48.6349 63.6767 48.4535 63.5228 48.3379 63.3228L47.1579 61.2788C47.0423 61.0787 46.9995 60.8447 47.0369 60.6166C47.0743 60.3886 47.1895 60.1805 47.3629 60.0278L48.6299 58.9138C48.512 58.1761 48.512 57.4244 48.6299 56.6868L47.3629 55.5738C47.1896 55.4213 47.0743 55.2134 47.0367 54.9856C46.9992 54.7577 47.0417 54.5239 47.1569 54.3238L48.3369 52.2788C48.4526 52.0785 48.6341 51.9245 48.8505 51.843C49.0669 51.7615 49.3049 51.7575 49.5239 51.8318L51.1219 52.3718C51.7015 51.8993 52.3531 51.5229 53.0519 51.2568L53.3819 49.6048ZM55.5419 60.8008C56.3376 60.8008 57.1006 60.4847 57.6633 59.9221C58.2259 59.3595 58.5419 58.5964 58.5419 57.8008C58.5419 57.0051 58.2259 56.2421 57.6633 55.6795C57.1006 55.1169 56.3376 54.8008 55.5419 54.8008C54.7463 54.8008 53.9832 55.1169 53.4206 55.6795C52.858 56.2421 52.5419 57.0051 52.5419 57.8008C52.5419 58.5964 52.858 59.3595 53.4206 59.9221C53.9832 60.4847 54.7463 60.8008 55.5419 60.8008Z"
                  fill={secondColor}
               />
            </g>
         </g>
         <defs>
            <clipPath id="clip0_1530_24812">
               <rect width="72" height="72" fill="none" />
            </clipPath>
            <clipPath id="clip1_1530_24812">
               <rect width="72" height="72" fill="none" />
            </clipPath>
         </defs>
      </svg>
   );
};

export const Icon_MessagesWithСhart: React.FC<IconProps> = ({
   fill,
   stroke,
   secondColor,
   className,
}) => {
   return (
      <svg
         width="72"
         height="72"
         viewBox="0 0 72 72"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <g clipPath="url(#clip0_1530_24840)">
            <path
               fillRule="evenodd"
               clipRule="evenodd"
               d="M7.93609 24.6958C8.53282 23.6623 9.51571 22.9081 10.6685 22.5992L51.2374 11.7288C52.3902 11.4199 53.6185 11.5816 54.6521 12.1783C55.4637 12.6469 56.103 13.3536 56.4897 14.1936L36.3098 37.156L7.35228 27.36C7.26717 26.4391 7.46751 25.5074 7.93609 24.6958ZM4.59407 28.9068L12.3533 57.8648C12.8682 59.7861 14.1251 61.4242 15.8478 62.4188C17.5704 63.4134 19.6176 63.6829 21.5389 63.1681L38.9256 58.5093C39.7258 58.2949 40.2007 57.4724 39.9862 56.6722C39.7718 55.872 38.9493 55.3971 38.1491 55.6115L20.7625 60.2703C19.6097 60.5792 18.3814 60.4175 17.3478 59.8207C16.3142 59.224 15.56 58.2411 15.2511 57.0883L8.21195 30.8178L36.2957 40.3182C36.8693 40.5122 37.5034 40.3424 37.9031 39.8875L57.4742 17.618L61.4075 32.2974C61.6219 33.0976 62.4444 33.5725 63.2446 33.3581C64.0448 33.1437 64.5197 32.3212 64.3053 31.521L59.6518 14.1541C59.648 14.139 59.644 14.124 59.6397 14.1091C59.1207 12.1986 57.8672 10.5705 56.1521 9.58025C54.4295 8.58569 52.3823 8.31617 50.4609 8.83099L9.89206 19.7014C7.97071 20.2162 6.33257 21.4732 5.33801 23.1958C4.34782 24.9109 4.07632 26.9477 4.58202 28.8617C4.5858 28.8768 4.58982 28.8918 4.59407 28.9068Z"
               fill={stroke}
            />
            <path
               d="M62.5 42C62.1022 42 61.7206 42.158 61.4393 42.4393C61.158 42.7206 61 43.1022 61 43.5V56.5C61 56.8978 61.158 57.2794 61.4393 57.5607C61.7206 57.842 62.1022 58 62.5 58H63.5C63.8978 58 64.2794 57.842 64.5607 57.5607C64.842 57.2794 65 56.8978 65 56.5V43.5C65 43.1022 64.842 42.7206 64.5607 42.4393C64.2794 42.158 63.8978 42 63.5 42H62.5ZM56.5 46C56.1022 46 55.7206 46.158 55.4393 46.4393C55.158 46.7206 55 47.1022 55 47.5V56.5C55 56.8978 55.158 57.2794 55.4393 57.5607C55.7206 57.842 56.1022 58 56.5 58H57.5C57.8978 58 58.2794 57.842 58.5607 57.5607C58.842 57.2794 59 56.8978 59 56.5V47.5C59 47.1022 58.842 46.7206 58.5607 46.4393C58.2794 46.158 57.8978 46 57.5 46H56.5ZM50.5 50C50.1022 50 49.7206 50.158 49.4393 50.4393C49.158 50.7206 49 51.1022 49 51.5V56.5C49 56.8978 49.158 57.2794 49.4393 57.5607C49.7206 57.842 50.1022 58 50.5 58H51.5C51.8978 58 52.2794 57.842 52.5607 57.5607C52.842 57.2794 53 56.8978 53 56.5V51.5C53 51.1022 52.842 50.7206 52.5607 50.4393C52.2794 50.158 51.8978 50 51.5 50H50.5Z"
               fill={secondColor}
            />
         </g>
         <defs>
            <clipPath id="clip0_1530_24840">
               <rect width="72" height="72" fill="white" />
            </clipPath>
         </defs>
      </svg>
   );
};

export const Icon_PersonWithPlus: React.FC<IconProps> = ({
   fill,
   stroke,
   secondColor,
   className,
}) => {
   return (
      <svg
         width="72"
         height="72"
         viewBox="0 0 72 72"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <g clipPath="url(#clip0_1530_24871)">
            <g clipPath="url(#clip1_1530_24871)">
               <path
                  d="M24 21C24 24.1826 25.2643 27.2348 27.5147 29.4853C29.7652 31.7357 32.8174 33 36 33C39.1826 33 42.2348 31.7357 44.4853 29.4853C46.7357 27.2348 48 24.1826 48 21C48 17.8174 46.7357 14.7652 44.4853 12.5147C42.2348 10.2643 39.1826 9 36 9C32.8174 9 29.7652 10.2643 27.5147 12.5147C25.2643 14.7652 24 17.8174 24 21Z"
                  stroke={stroke}
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M48 57H66"
                  stroke={secondColor}
                  strokeWidth="5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M57 48V66"
                  stroke={secondColor}
                  strokeWidth="5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M18 63V57C18 53.8174 19.2643 50.7652 21.5147 48.5147C23.7652 46.2643 26.8174 45 30 45H42"
                  stroke={stroke}
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
            </g>
         </g>
         <defs>
            <clipPath id="clip0_1530_24871">
               <rect width="72" height="72" fill="white" />
            </clipPath>
            <clipPath id="clip1_1530_24871">
               <rect width="72" height="72" fill="white" />
            </clipPath>
         </defs>
      </svg>
   );
};

export const Icon_PersonWithCheckMark: React.FC<IconProps> = ({
   fill,
   stroke,
   secondColor,
   className,
}) => {
   return (
      <svg
         width="72"
         height="72"
         viewBox="0 0 72 72"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <g clipPath="url(#clip0_1530_24871)">
            <g clipPath="url(#clip1_1530_24871)">
               <path
                  d="M24 21C24 24.1826 25.2643 27.2348 27.5147 29.4853C29.7652 31.7357 32.8174 33 36 33C39.1826 33 42.2348 31.7357 44.4853 29.4853C46.7357 27.2348 48 24.1826 48 21C48 17.8174 46.7357 14.7652 44.4853 12.5147C42.2348 10.2643 39.1826 9 36 9C32.8174 9 29.7652 10.2643 27.5147 12.5147C25.2643 14.7652 24 17.8174 24 21Z"
                  stroke={stroke}
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
               <path
                  d="M18 63V57C18 53.8174 19.2643 50.7652 21.5147 48.5147C23.7652 46.2643 26.8174 45 30 45H42"
                  stroke={stroke}
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
            </g>
         </g>
         <path
            d="M45.1286 58.9547L52.4771 63.1974L60.9623 48.5004"
            stroke={secondColor}
            strokeWidth="6"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </svg>
   );
};

export const Icon_ChevronDown: React.FC<IconProps> = ({
   fill,
   stroke,
   className,
   width = 14,
   height = 8,
}) => {
   return (
      <svg
         width={width}
         height={height}
         viewBox="0 0 14 8"
         fill={fill}
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M1 1L7 7L13 1"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </svg>
   );
};

export const Icon_ChevronUp: React.FC<IconProps> = ({
   fill,
   stroke,
   className,
   width = 14,
   height = 8,
}) => {
   return (
      <svg
         width={width}
         height={height}
         viewBox="0 0 14 8"
         fill={fill}
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M1 7L7 1L13 7"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </svg>
   );
};

export const Icon_PlannedLock: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="16"
         height="16"
         viewBox="0 0 16 16"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.99996 1V1.99996H9.99996V1H11V1.99996H14.3333C14.7015 1.99996 15 2.29844 15 2.66663V7H14V6.00004H2V13H6V14H1.66667C1.29848 14 1 13.7015 1 13.3333V2.66662C1 2.29844 1.29848 1.99996 1.66667 1.99996L5 1.99996V1H5.99996ZM2 3H5V4H6V3H9.99996L10 4H11V3H14V5H2V3Z"
            fill={fill}
            stroke={stroke}
         />
         <path
            d="M15 11H16V16H8V11H9V10C9 8.3431 10.3431 7 12 7C13.6569 7 15 8.3431 15 10V11ZM13 11V10C13 9.4477 12.5523 9 12 9C11.4477 9 11 9.4477 11 10V11H13Z"
            fill={fill}
            stroke={stroke}
         />
      </svg>
   );
};

export const Icon_Thunder: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="12"
         height="16"
         viewBox="0 0 12 16"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M6.66797 6.66663H11.3346L5.33464 15.3333V9.33329H0.667969L6.66797 0.666626V6.66663Z"
            fill={fill}
            stroke={stroke}
         />
      </svg>
   );
};

export const Icon_Comment: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="15"
         height="13"
         viewBox="0 0 15 13"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M3.1665 10H13.6665V1H1.6665V11L3.1665 10ZM3.6665 11L0.666504 13V0.666667C0.666504 0.29848 0.964984 0 1.33317 0H13.9998C14.368 0 14.6665 0.29848 14.6665 0.666667V10.3333C14.6665 10.7015 14.368 11 13.9998 11H3.6665Z"
            fill={fill}
            stroke={stroke}
         />
      </svg>
   );
};

export const Icon_SendComment: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="16"
         height="16"
         viewBox="0 0 16 16"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M0.45961 5.98654C0.067705 5.85591 0.0646149 5.64514 0.467672 5.51078L14.7824 0.739229C15.1787 0.607109 15.406 0.828966 15.295 1.21768L11.2051 15.5324C11.0918 15.9287 10.8633 15.9425 10.6958 15.5657L8.00003 9.50003L12.5 3.50001L6.50003 8.00003L0.45961 5.98654Z"
            fill={fill}
            stroke={stroke}
         />
      </svg>
   );
};

export const Icon_Refresh: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         fill={fill}
         stroke={stroke}
         height="24"
         viewBox="0 -960 960 960"
         width="24"
         className={className}
      >
         <path d="M480-160q-134 0-227-93t-93-227q0-134 93-227t227-93q69 0 132 28.5T720-690v-110h80v280H520v-80h168q-32-56-87.5-88T480-720q-100 0-170 70t-70 170q0 100 70 170t170 70q77 0 139-44t87-116h84q-28 106-114 173t-196 67Z" />
      </svg>
   );
};

export const Icon_FolderMove: React.FC<IconProps> = ({ fill, className, onClick }) => {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         fill={fill}
         height="24"
         viewBox="0 -960 960 960"
         width="24"
         onClick={onClick}
         className={className}
      >
         <path d="m488-400-65 65 56 56 161-161-161-161-56 56 65 65H320v80h168ZM160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h240l80 80h320q33 0 56.5 23.5T880-640v400q0 33-23.5 56.5T800-160H160Zm0-80h640v-400H447l-80-80H160v480Zm0 0v-480 480Z" />
      </svg>
   );
};

export const Icon_ChatOptions: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="8"
         height="16"
         viewBox="0 0 4 19"
         fill={fill}
         stroke={stroke}
         className={className}
         xmlns="http://www.w3.org/2000/svg"
      >
         <path d="M2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0ZM2 14C0.9 14 0 14.9 0 16C0 17.1 0.9 18 2 18C3.1 18 4 17.1 4 16C4 14.9 3.1 14 2 14ZM2 7C0.9 7 0 7.9 0 9C0 10.1 0.9 11 2 11C3.1 11 4 10.1 4 9C4 7.9 3.1 7 2 7Z" />
      </svg>
   );
};
export const Icon_SpamInfo: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         x="0px"
         y="0px"
         width="17"
         height="20"
         viewBox="0 0 128 128"
         fill={fill}
         stroke={stroke}
         className={className}
      >
         <path d="M 64 6 C 32 6 6 32 6 64 C 6 96 32 122 64 122 C 96 122 122 96 122 64 C 122 32 96 6 64 6 z M 64 12 C 92.7 12 116 35.3 116 64 C 116 92.7 92.7 116 64 116 C 35.3 116 12 92.7 12 64 C 12 35.3 35.3 12 64 12 z M 64 30 A 9 9 0 0 0 64 48 A 9 9 0 0 0 64 30 z M 64 59 C 59 59 55 63 55 68 L 55 92 C 55 97 59 101 64 101 C 69 101 73 97 73 92 L 73 68 C 73 63 69 59 64 59 z"></path>
      </svg>
   );
};

export const Icon_ChatSendMessage: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="14"
         height="14"
         viewBox="0 0 14 14"
         fill={fill}
         stroke={stroke}
         className={className}
         xmlns="http://www.w3.org/2000/svg"
      >
         <path
            d="M13.4843 0.971051L9.8488 13.6952C9.74813 14.0475 9.53173 14.0635 9.37073 13.7415L6.3332 7.66648L0.281773 5.24588C-0.0580136 5.10997 -0.053807 4.90657 0.304466 4.78714L13.0286 0.545764C13.3809 0.428324 13.583 0.625531 13.4843 0.971051ZM11.6901 2.39741L3.54131 5.11366L7.29907 6.61674L9.3262 10.671L11.6901 2.39741Z"
            fill="#1C4387"
         />
      </svg>
   );
};

export const Icon_SearchInList: React.FC<IconProps> = ({ fill, className }) => {
   return (
      <svg
         width="20"
         height="17"
         viewBox="0 0 20 17"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M12.5 2C10.567 2 9 3.567 9 5.5C9 7.433 10.567 9 12.5 9C14.433 9 16 7.433 16 5.5C16 3.567 14.433 2 12.5 2ZM7 5.5C7 2.46243 9.4624 0 12.5 0C15.5376 0 18 2.46243 18 5.5C18 6.6575 17.6424 7.7315 17.0317 8.6175L19.7071 11.2929L18.2929 12.7071L15.6175 10.0317C14.7315 10.6424 13.6575 11 12.5 11C9.4624 11 7 8.5376 7 5.5ZM0 1H5V3H0V1ZM0 8H5V10H0V8ZM18 15V17H0V15H18Z"
            fill={fill}
         />
      </svg>
   );
};

export const Icon_SandGlass: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="12"
         height="15"
         viewBox="0 0 12 15"
         fill={fill}
         stroke={stroke}
         className={className}
         xmlns="http://www.w3.org/2000/svg"
      >
         <path
            d="M0.666748 0.833496H11.3334V3.80679L7.02448 7.50016L11.3334 11.1936V14.1668H0.666748V11.1936L4.97568 7.50016L0.666748 3.80679V0.833496ZM8.86455 4.16683L10.0001 3.19354V2.16683H2.00008V3.19354L3.13559 4.16683H8.86455ZM6.00008 8.37823L2.00008 11.8068V12.8335H2.66675L6.00008 10.8335L9.33342 12.8335H10.0001V11.8068L6.00008 8.37823Z"
            fill="#CBD5E1"
         />
      </svg>
   );
};

export const Icon_Lock: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="12"
         height="13"
         viewBox="0 0 12 13"
         fill={fill}
         stroke={stroke}
         className={className}
         xmlns="http://www.w3.org/2000/svg"
      >
         <path
            d="M10.6667 5H11.3333C11.7015 5 12 5.29101 12 5.65V12.35C12 12.709 11.7015 13 11.3333 13H0.666667C0.29848 13 0 12.709 0 12.35V5.65C0 5.29101 0.29848 5 0.666667 5H1.33333V4.55C1.33333 2.03711 3.42267 0 6 0C8.57733 0 10.6667 2.03711 10.6667 4.55V5ZM9.33333 5V4.55C9.33333 2.75508 7.84093 1.3 6 1.3C4.15905 1.3 2.66667 2.75508 2.66667 4.55V5H9.33333ZM5.33333 7.8V10.4H6.66667V7.8H5.33333Z"
            fill={fill ? fill : "#94A3B8"}
         />
      </svg>
   );
};

export const Icon_Unlock: React.FC<IconProps> = ({ fill, stroke, className }) => {
   return (
      <svg
         width="12"
         height="13"
         viewBox="0 0 12 13"
         fill={fill}
         stroke={stroke}
         className={className}
         xmlns="http://www.w3.org/2000/svg"
      >
         <path
            d="M2.66667 5H11.3333C11.7015 5 12 5.29101 12 5.65V12.35C12 12.709 11.7015 13 11.3333 13H0.666667C0.29848 13 0 12.709 0 12.35V5.65C0 5.29101 0.29848 5 0.666667 5H1.33333V4.55C1.33333 2.03711 3.42267 0 6 0C7.827 0 9.40873 1.02362 10.1749 2.51473L8.98207 3.09624C8.4348 2.03116 7.305 1.3 6 1.3C4.15905 1.3 2.66667 2.75508 2.66667 4.55V5ZM4.66667 8.45V9.75H7.33333V8.45H4.66667Z"
            fill={fill ? fill : "#94A3B8"}
         />
      </svg>
   );
};

export const Icon_Table: React.FC<IconProps> = ({ fill, className }) => {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         className={className}
         fill={fill}
         height="24"
         viewBox="0 -960 960 960"
         width="24"
      >
         <path d="M120-120v-720h720v720H120Zm80-480h560v-160H200v160Zm213 200h134v-120H413v120Zm0 200h134v-120H413v120ZM200-400h133v-120H200v120Zm427 0h133v-120H627v120ZM200-200h133v-120H200v120Zm427 0h133v-120H627v120Z" />
      </svg>
   );
};

export const Icon_ViewModules: React.FC<IconProps> = ({ fill, className }) => {
   return (
      <svg
         className={className}
         fill={fill}
         xmlns="http://www.w3.org/2000/svg"
         height="24"
         viewBox="0 -960 960 960"
         width="24"
      >
         <path d="M121-200v-560h719v560H121Zm506-320h133v-160H627v160Zm-213 0h133v-160H414v160Zm-213 0h133v-160H201v160Zm0 240h133v-160H201v160Zm213 0h133v-160H414v160Zm213 0h133v-160H627v160Z" />
      </svg>
   );
};

export const Icon_ContentCopy: React.FC<IconProps> = ({ fill, className }) => {
   return (
      <svg
         className={className}
         fill={fill}
         xmlns="http://www.w3.org/2000/svg"
         height="24"
         viewBox="0 -960 960 960"
         width="24"
      >
         <path d="M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360Zm0-80h360v-480H360v480ZM200-80q-33 0-56.5-23.5T120-160v-560h80v560h440v80H200Zm160-240v-480 480Z" />
      </svg>
   );
};

export const Icon_Empty_Simple: React.FC<IconProps> = () => {
   return (
      <svg width="64" height="41" viewBox="0 0 64 41" xmlns="http://www.w3.org/2000/svg">
         <g transform="translate(0 1)" fill="none" fillRule="evenodd">
            <ellipse fill="#f5f5f5" cx="32" cy="33" rx="32" ry="7"></ellipse>
            <g fillRule="nonzero" stroke="#d9d9d9">
               <path d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"></path>
               <path
                  d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z"
                  fill="#fafafa"
               ></path>
            </g>
         </g>
      </svg>
   );
};

export const Icon_Empty_Default: React.FC<IconProps> = () => {
   return (
      <svg width="184" height="152" viewBox="0 0 184 152" xmlns="http://www.w3.org/2000/svg">
         <g fill="none" fillRule="evenodd">
            <g transform="translate(24 31.67)">
               <ellipse
                  fill-opacity=".8"
                  fill="#F5F5F7"
                  cx="67.797"
                  cy="106.89"
                  rx="67.797"
                  ry="12.668"
               ></ellipse>
               <path
                  d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
                  fill="#AEB8C2"
               ></path>
               <path
                  d="M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z"
                  fill="url(#linearGradient-1)"
                  transform="translate(13.56)"
               ></path>
               <path
                  d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
                  fill="#F5F5F7"
               ></path>
               <path
                  d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
                  fill="#DCE0E6"
               ></path>
            </g>
            <path
               d="M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
               fill="#DCE0E6"
            ></path>
            <g transform="translate(149.65 15.383)" fill="#FFF">
               <ellipse cx="20.654" cy="3.167" rx="2.849" ry="2.815"></ellipse>
               <path d="M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"></path>
            </g>
         </g>
      </svg>
   );
};

export const Icon_Clock: React.FC<IconProps> = ({ fill, className }) => {
   return (
      <svg
         width="1em"
         height="1em"
         viewBox="0 0 16 17"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M7.99992 15.1668C4.31802 15.1668 1.33325 12.182 1.33325 8.50016C1.33325 4.81826 4.31802 1.8335 7.99992 1.8335C11.6818 1.8335 14.6666 4.81826 14.6666 8.50016C14.6666 12.182 11.6818 15.1668 7.99992 15.1668ZM7.99992 13.8335C10.9455 13.8335 13.3333 11.4457 13.3333 8.50016C13.3333 5.55464 10.9455 3.16683 7.99992 3.16683C5.0544 3.16683 2.66659 5.55464 2.66659 8.50016C2.66659 11.4457 5.0544 13.8335 7.99992 13.8335ZM8.66658 8.50016H11.3333V9.8335H7.33325V5.16683H8.66658V8.50016Z"
            fill={fill}
         />
      </svg>
   );
};

export const Icon_Person: React.FC<IconProps> = ({ fill, className }) => {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         fill={fill}
         className={className}
         height="24"
         viewBox="0 -960 960 960"
         width="24"
      >
         <path d="M480-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Zm80-80h480v-32q0-11-5.5-20T700-306q-54-27-109-40.5T480-360q-56 0-111 13.5T260-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T560-640q0-33-23.5-56.5T480-720q-33 0-56.5 23.5T400-640q0 33 23.5 56.5T480-560Zm0-80Zm0 400Z" />
      </svg>
   );
};

export const Icon_Upload: React.FC<IconProps> = ({ className, style }) => {
   return (
      <svg
         style={style}
         viewBox="64 64 896 896"
         focusable="false"
         className={className}
         data-icon="cloud-upload"
         width="1em"
         height="1em"
         fill="currentColor"
         aria-hidden="true"
      >
         <path d="M518.3 459a8 8 0 0 0-12.6 0l-112 141.7a7.98 7.98 0 0 0 6.3 12.9h73.9V856c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V613.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 459z"></path>
         <path d="M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 0 1-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z"></path>
      </svg>
   );
};

export const Icon_Upload_Barcode: React.FC<IconProps> = ({ className }) => {
   return (
      <svg
         viewBox="64 64 896 896"
         focusable="false"
         className={className}
         data-icon="barcode"
         width="1em"
         height="1em"
         fill="currentColor"
         aria-hidden="true"
      >
         <path d="M120 160H72c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zm833 0h-48c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zM200 736h112c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm321 0h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm126 0h178c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H647c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm-255 0h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm-79 64H201c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm257 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm256 0H648c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h178c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-385 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"></path>
      </svg>
   );
};

export const Icon_Eye: React.FC<IconProps> = ({ className }) => {
   return (
      <svg
         viewBox="64 64 896 896"
         focusable="false"
         className={className}
         data-icon="eye"
         width="1em"
         height="1em"
         fill="currentColor"
         aria-hidden="true"
      >
         <path d="M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"></path>
      </svg>
   );
};

export const Icon_Eye_Invisible: React.FC<IconProps> = ({ className }) => {
   return (
      <svg
         viewBox="64 64 896 896"
         focusable="false"
         className={className}
         data-icon="eye-invisible"
         width="1em"
         height="1em"
         fill="currentColor"
         aria-hidden="true"
      >
         <path d="M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5zm-63.57-320.64L836 122.88a8 8 0 0 0-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 0 0 0 11.31L155.17 889a8 8 0 0 0 11.31 0l712.15-712.12a8 8 0 0 0 0-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 0 0-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 0 1 146.2-106.69L401.31 546.2A112 112 0 0 1 396 512z"></path>
         <path d="M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 0 0 227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 0 1-112 112z"></path>
      </svg>
   );
};

export const Icon_ShoppingCart: React.FC<IconProps> = ({ className }) => {
   return (
      <svg
         viewBox="0 0 1024 1024"
         focusable="false"
         className={className}
         data-icon="shopping-cart"
         width="1em"
         height="1em"
         fill="currentColor"
         aria-hidden="true"
      >
         <path d="M922.9 701.9H327.4l29.9-60.9 496.8-.9c16.8 0 31.2-12 34.2-28.6l68.8-385.1c1.8-10.1-.9-20.5-7.5-28.4a34.99 34.99 0 0 0-26.6-12.5l-632-2.1-5.4-25.4c-3.4-16.2-18-28-34.6-28H96.5a35.3 35.3 0 1 0 0 70.6h125.9L246 312.8l58.1 281.3-74.8 122.1a34.96 34.96 0 0 0-3 36.8c6 11.9 18.1 19.4 31.5 19.4h62.8a102.43 102.43 0 0 0-20.6 61.7c0 56.6 46 102.6 102.6 102.6s102.6-46 102.6-102.6c0-22.3-7.4-44-20.6-61.7h161.1a102.43 102.43 0 0 0-20.6 61.7c0 56.6 46 102.6 102.6 102.6s102.6-46 102.6-102.6c0-22.3-7.4-44-20.6-61.7H923c19.4 0 35.3-15.8 35.3-35.3a35.42 35.42 0 0 0-35.4-35.2zM305.7 253l575.8 1.9-56.4 315.8-452.3.8L305.7 253zm96.9 612.7c-17.4 0-31.6-14.2-31.6-31.6 0-17.4 14.2-31.6 31.6-31.6s31.6 14.2 31.6 31.6a31.6 31.6 0 0 1-31.6 31.6zm325.1 0c-17.4 0-31.6-14.2-31.6-31.6 0-17.4 14.2-31.6 31.6-31.6s31.6 14.2 31.6 31.6a31.6 31.6 0 0 1-31.6 31.6z"></path>
      </svg>
   );
};

export const Icon_Copy: React.FC<IconProps> = ({ className, id }) => {
   return (
      <svg
         viewBox="64 64 896 896"
         focusable="false"
         className={className}
         data-icon="copy"
         width="1em"
         height="1em"
         fill="currentColor"
         aria-hidden="true"
         id={id}
      >
         <path d="M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z"></path>
      </svg>
   );
};

export const Icon_Delete: React.FC<IconProps> = ({ className, id }) => {
   return (
      <svg
         viewBox="64 64 896 896"
         focusable="false"
         className={className}
         data-icon="delete"
         width="1em"
         height="1em"
         fill="currentColor"
         aria-hidden="true"
         id={id}
      >
         <path d="M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z"></path>
      </svg>
   );
};

export const Icon_Edit: React.FC<IconProps> = ({ className, id, onClick }) => {
   return (
      <svg
         viewBox="64 64 896 896"
         focusable="false"
         className={className}
         data-icon="edit"
         width="1em"
         height="1em"
         fill="currentColor"
         aria-hidden="true"
         id={id}
         onClick={onClick}
      >
         <path d="M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 0 0 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 0 0 9.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z"></path>
      </svg>
   );
};

export const Icon_Share: React.FC<IconProps> = ({ className, id, onClick }) => {
   return (
      <svg
         viewBox="64 64 896 896"
         focusable="false"
         className={className}
         data-icon="share-alt"
         width="1em"
         height="1em"
         fill="currentColor"
         aria-hidden="true"
         id={id}
         onClick={onClick}
      >
         <path d="M752 664c-28.5 0-54.8 10-75.4 26.7L469.4 540.8a160.68 160.68 0 0 0 0-57.6l207.2-149.9C697.2 350 723.5 360 752 360c66.2 0 120-53.8 120-120s-53.8-120-120-120-120 53.8-120 120c0 11.6 1.6 22.7 4.7 33.3L439.9 415.8C410.7 377.1 364.3 352 312 352c-88.4 0-160 71.6-160 160s71.6 160 160 160c52.3 0 98.7-25.1 127.9-63.8l196.8 142.5c-3.1 10.6-4.7 21.8-4.7 33.3 0 66.2 53.8 120 120 120s120-53.8 120-120-53.8-120-120-120zm0-476c28.7 0 52 23.3 52 52s-23.3 52-52 52-52-23.3-52-52 23.3-52 52-52zM312 600c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88zm440 236c-28.7 0-52-23.3-52-52s23.3-52 52-52 52 23.3 52 52-23.3 52-52 52z"></path>
      </svg>
   );
};

export const Icon_Plus: React.FC<IconProps> = ({ className }) => {
   return (
      <svg
         width="24"
         height="25"
         viewBox="0 0 24 25"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M11 11.97V5.97H13V11.97H19V13.97H13V19.97H11V13.97H5V11.97H11Z"
            fill="currentColor"
         />
      </svg>
   );
};

export const Icon_User: React.FC<IconProps> = ({ className }) => {
   return (
      <svg
         viewBox="64 64 896 896"
         focusable="false"
         className={className}
         data-icon="user"
         width="1em"
         height="1em"
         fill="currentColor"
         aria-hidden="true"
      >
         <path d="M858.5 763.6a374 374 0 0 0-80.6-119.5 375.63 375.63 0 0 0-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 0 0-80.6 119.5A371.7 371.7 0 0 0 136 901.8a8 8 0 0 0 8 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 0 0 8-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z"></path>
      </svg>
   );
};

export const Icon_DeploymentUnit: React.FC<IconProps> = ({ className }) => {
   return (
      <svg
         viewBox="64 64 896 896"
         focusable="false"
         className={className}
         data-icon="deployment-unit"
         width="1em"
         height="1em"
         fill="currentColor"
         aria-hidden="true"
      >
         <path d="M888.3 693.2c-42.5-24.6-94.3-18-129.2 12.8l-53-30.7V523.6c0-15.7-8.4-30.3-22-38.1l-136-78.3v-67.1c44.2-15 76-56.8 76-106.1 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 49.3 31.8 91.1 76 106.1v67.1l-136 78.3c-13.6 7.8-22 22.4-22 38.1v151.6l-53 30.7c-34.9-30.8-86.8-37.4-129.2-12.8-53.5 31-71.7 99.4-41 152.9 30.8 53.5 98.9 71.9 152.2 41 42.5-24.6 62.7-73 53.6-118.8l48.7-28.3 140.6 81c6.8 3.9 14.4 5.9 22 5.9s15.2-2 22-5.9L674.5 740l48.7 28.3c-9.1 45.7 11.2 94.2 53.6 118.8 53.3 30.9 121.5 12.6 152.2-41 30.8-53.6 12.6-122-40.7-152.9zm-673 138.4a47.6 47.6 0 0 1-65.2-17.6c-13.2-22.9-5.4-52.3 17.5-65.5a47.6 47.6 0 0 1 65.2 17.6c13.2 22.9 5.4 52.3-17.5 65.5zM522 463.8zM464 234a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm170 446.2l-122 70.3-122-70.3V539.8l122-70.3 122 70.3v140.4zm239.9 133.9c-13.2 22.9-42.4 30.8-65.2 17.6-22.8-13.2-30.7-42.6-17.5-65.5s42.4-30.8 65.2-17.6c22.9 13.2 30.7 42.5 17.5 65.5z"></path>
      </svg>
   );
};

export const Icon_Save: React.FC<IconProps> = ({ className }) => {
   return (
      <svg
         viewBox="64 64 896 896"
         focusable="false"
         className={className}
         data-icon="save"
         width="1em"
         height="1em"
         fill="currentColor"
         aria-hidden="true"
      >
         <path d="M893.3 293.3L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840zM512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z"></path>
      </svg>
   );
};

export const Icon_Minus: React.FC<IconProps> = ({ className }) => {
   return (
      <svg
         viewBox="64 64 896 896"
         focusable="false"
         className={className}
         data-icon="minus"
         width="1em"
         height="1em"
         fill="currentColor"
         aria-hidden="true"
      >
         <path d="M872 474H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"></path>
      </svg>
   );
};

export const Icon_Loading: React.FC<IconProps> = () => {
   return (
      <svg
         viewBox="0 0 1024 1024"
         focusable="false"
         className="icon-spin"
         data-icon="loading"
         width="1em"
         height="1em"
         fill="currentColor"
         aria-hidden="true"
      >
         <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
      </svg>
   );
};

export const Icon_Filter: React.FC<IconProps> = ({ className, style }) => {
   return (
      <svg
         viewBox="64 64 896 896"
         focusable="false"
         className={className}
         style={style}
         data-icon="filter"
         width="1em"
         height="1em"
         fill="currentColor"
         aria-hidden="true"
      >
         <path d="M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 597.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V597.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.4 798H420.6V642h182.9v156zm9.6-236.6l-9.5 16.6h-183l-9.5-16.6L212.7 226h598.6L613 561.4z"></path>
      </svg>
   );
};

export const Icon_ArrowUp: React.FC<IconProps> = ({ className }) => {
   return (
      <svg
         viewBox="64 64 896 896"
         focusable="false"
         className={className}
         data-icon="arrow-up"
         width="1em"
         height="1em"
         fill="currentColor"
         aria-hidden="true"
      >
         <path d="M868 545.5L536.1 163a31.96 31.96 0 0 0-48.3 0L156 545.5a7.97 7.97 0 0 0 6 13.2h81c4.6 0 9-2 12.1-5.5L474 300.9V864c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V300.9l218.9 252.3c3 3.5 7.4 5.5 12.1 5.5h81c6.8 0 10.5-8 6-13.2z"></path>
      </svg>
   );
};

export const Icon_ArrowDown: React.FC<IconProps> = ({ className }) => {
   return (
      <svg
         viewBox="64 64 896 896"
         focusable="false"
         className={className}
         data-icon="arrow-down"
         width="1em"
         height="1em"
         fill="currentColor"
         aria-hidden="true"
      >
         <path d="M862 465.3h-81c-4.6 0-9 2-12.1 5.5L550 723.1V160c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v563.1L255.1 470.8c-3-3.5-7.4-5.5-12.1-5.5h-81c-6.8 0-10.5 8.1-6 13.2L487.9 861a31.96 31.96 0 0 0 48.3 0L868 478.5c4.5-5.2.8-13.2-6-13.2z"></path>
      </svg>
   );
};

export const Icon_ArrowRight: React.FC<IconProps> = ({ className }) => {
   return (
      <svg
         viewBox="64 64 896 896"
         focusable="false"
         className={className}
         data-icon="arrow-right"
         width="1em"
         height="1em"
         fill="currentColor"
         aria-hidden="true"
      >
         <path d="M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 0 0 0-48.4z"></path>
      </svg>
   );
};

export const Icon_ArrowRight2: React.FC<IconProps> = ({ className, fill }) => {
   return (
      <svg
         className={className}
         width="24"
         height="25"
         viewBox="0 0 24 25"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <path
            d="M12.031 13.3144L12.7412 12.5391L12.5537 12.3574L12.031 11.7754L7.87501 7.63268L8.96624 6.54492L14.9912 12.5391L8.96623 18.5449L7.87501 17.4572L12.031 13.3144Z"
            fill={fill || "#808080"}
         />
      </svg>
   );
};

export const Icon_ArrowLeft: React.FC<IconProps> = ({ className }) => {
   return (
      <svg
         viewBox="64 64 896 896"
         focusable="false"
         className={className}
         data-icon="arrow-left"
         width="1em"
         height="1em"
         fill="currentColor"
         aria-hidden="true"
      >
         <path d="M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 0 0 0 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"></path>
      </svg>
   );
};

export const Icon_UpCircle: React.FC<IconProps> = ({ className, style }) => {
   return (
      <svg
         viewBox="64 64 896 896"
         focusable="false"
         className={className}
         style={style}
         data-icon="up-circle"
         width="1em"
         height="1em"
         fill="currentColor"
         aria-hidden="true"
      >
         <path d="M518.5 360.3a7.95 7.95 0 0 0-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7H381c10.2 0 19.9-4.9 25.9-13.2L512 460.4l105.2 145.4c6 8.3 15.6 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.5-12.7l-178-246z"></path>
         <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path>
      </svg>
   );
};

export const Icon_Flag: React.FC<IconProps> = () => {
   return (
      <svg
         width="24"
         height="24"
         viewBox="0 0 24 24"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <path
            d="M21.1384 3C21.4146 3 21.6385 3.22386 21.6385 3.5C21.6385 3.58701 21.6157 3.67252 21.5725 3.74807L18 10L21.5725 16.2519C21.7095 16.4917 21.6262 16.7971 21.3865 16.9341C21.3109 16.9773 21.2254 17 21.1384 17H4V22H2V3H21.1384ZM18.5536 5H4V15H18.5536L15.6965 10L18.5536 5Z"
            fill="#1C4387"
         />
      </svg>
   );
};

export const Icon_Plan_Add: React.FC<IconProps> = ({ className, fill }) => {
   return (
      <svg
         width="16"
         height="16"
         viewBox="0 0 16 16"
         className={className}
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <g clipPath="url(#clip0_2900_9832)">
            <path
               fillRule="evenodd"
               clipRule="evenodd"
               d="M5.99996 1V1.99996H9.99996V1H11V1.99996H14.3333C14.7015 1.99996 15 2.29844 15 2.66663V7H14V6.00004H2V13H6V14H1.66667C1.29848 14 1 13.7015 1 13.3333V2.66662C1 2.29844 1.29848 1.99996 1.66667 1.99996L5 1.99996V1H5.99996ZM2 3H5V4H6V3H9.99996L10 4H11V3H14V5H2V3Z"
               fill={fill}
            />
            <path d="M11 11V7.99996H13V11H16V13H13V16H11V13H7.99996V11H11Z" fill={fill} />
         </g>
         <defs>
            <clipPath id="clip0_2900_9832">
               <rect width="16" height="16" fill="white" />
            </clipPath>
         </defs>
      </svg>
   );
};

export const Icon_Planned_Check: React.FC<IconProps> = ({ className, fill }) => {
   return (
      <svg
         width="16"
         height="16"
         viewBox="0 0 16 16"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M6.00016 0.666504V1.99984H10.0002V0.666504H11.3335V1.99984H14.0002C14.3684 1.99984 14.6668 2.29832 14.6668 2.6665V13.3332C14.6668 13.7014 14.3684 13.9998 14.0002 13.9998H2.00016C1.63198 13.9998 1.3335 13.7014 1.3335 13.3332V2.6665C1.3335 2.29832 1.63198 1.99984 2.00016 1.99984H4.66683V0.666504H6.00016ZM13.3335 5.33317H2.66683V12.6665H13.3335V5.33317ZM10.0238 6.75717L10.9666 7.70004L7.66683 10.9998L5.30981 8.64284L6.25262 7.70004L7.66683 9.11424L10.0238 6.75717Z"
            fill={fill}
         />
      </svg>
   );
};

export const Icon_Pause: React.FC<IconProps> = ({ className, fill }) => {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         className={className}
         width="8"
         height="10"
         viewBox="0 0 8 10"
         fill="none"
      >
         <path d="M0 0H2V10H0V0ZM6 0H8V10H6V0Z" fill={fill} />
      </svg>
   );
};

export const Icon_MailThis: React.FC<IconProps> = ({ className, fill }) => {
   return (
      <svg
         width="16"
         height="16"
         viewBox="0 0 16 16"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M14 2C14.3682 2 14.6667 2.29848 14.6667 2.66667V13.3377C14.6667 13.7035 14.3631 14 14.0055 14H1.99453C1.62937 14 1.33333 13.7034 1.33333 13.3377V12.6667H13.3333V4.86667L8 9.66667L1.33333 3.66667V2.66667C1.33333 2.29848 1.63181 2 2 2H14ZM5.33333 10V11.3333H0V10H5.33333ZM3.33333 6.66667V8H0V6.66667H3.33333ZM13.0439 3.33333H2.95609L8 7.87287L13.0439 3.33333Z"
            fill={fill}
         />
      </svg>
   );
};

export const Icon_GoBack: React.FC<IconProps> = ({ className, fill, onClick }) => {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         width="20"
         height="20"
         viewBox="0 0 16 16"
         fill="none"
         className={className}
         onClick={onClick}
      >
         <path
            d="M5.21879 7.33327H13.3332V8.6666H5.21879L8.79477 12.2425L7.85197 13.1853L2.6665 7.99993L7.85197 2.81445L8.79477 3.75726L5.21879 7.33327Z"
            fill={fill}
         />
      </svg>
   );
};

export const Icon_Start: React.FC<IconProps> = ({ className, fill }) => {
   return (
      <svg
         stroke="currentColor"
         fill={fill}
         strokeWidth="0"
         viewBox="0 0 512 512"
         height="20px"
         width="20px"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path d="M96 52v408l320-204L96 52z"></path>
      </svg>
   );
};

export const Icon_PlannedCalendar: React.FC<IconProps> = ({ className, fill }) => {
   return (
      <svg
         width="14"
         height="13"
         viewBox="0 0 14 13"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.99996 0V0.999959H8.99996V0H10V0.999959H13.3333C13.7015 0.999959 14 1.29844 14 1.66663V12.3333C14 12.5555 13.8667 13 13.3333 13H0.666667C0.29848 13 0 12.7015 0 12.3333V1.66662C0 1.29844 0.29848 0.999958 0.666667 0.999958L4 0.999959V0H4.99996ZM1 5.00004H13V12H1V5.00004ZM1 2H4V3H5V2H8.99996L9 3H10V2H13V4H1V2Z"
            fill={fill}
         />
         <path d="M3 7V10H11V7H3Z" fill={fill} />
      </svg>
   );
};

export const Icon_CasesNotPlanned: React.FC<IconProps> = ({ className, stroke }) => {
   return (
      <svg
         width="19"
         height="18"
         viewBox="0 0 19 18"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M16.2083 5C17.2669 5 18.125 4.10457 18.125 3C18.125 1.89543 17.2669 1 16.2083 1H2.79167C1.73312 1 0.875 1.89543 0.875 3C0.875 4.10457 1.73312 5 2.79167 5M16.2083 5H2.79167M16.2083 5V15C16.2083 15.5304 16.0064 16.0391 15.647 16.4142C15.2875 16.7893 14.8 17 14.2917 17H4.70833C4.2 17 3.71249 16.7893 3.35305 16.4142C2.9936 16.0391 2.79167 15.5304 2.79167 15V5M7.58333 9H11.4167"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </svg>
   );
};

export const Icon_CasesPlanned: React.FC<IconProps> = ({ className, stroke }) => {
   return (
      <svg
         width="20"
         height="21"
         viewBox="0 0 20 21"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M9.30354 19H2.79167C2.28334 19 1.79582 18.7893 1.43638 18.4142C1.07693 18.0391 0.875 17.5304 0.875 17V5C0.875 4.46957 1.07693 3.96086 1.43638 3.58579C1.79582 3.21071 2.28334 3 2.79167 3H14.2917C14.8 3 15.2875 3.21071 15.647 3.58579C16.0064 3.96086 16.2083 4.46957 16.2083 5V9H0.875M12.375 1V5M4.70833 1V5M15.25 14.496V16L16.2083 17M19.0833 16C19.0833 18.2091 17.3671 20 15.25 20C13.1329 20 11.4167 18.2091 11.4167 16C11.4167 13.7909 13.1329 12 15.25 12C17.3671 12 19.0833 13.7909 19.0833 16Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </svg>
   );
};

export const Icon_CasesReceived: React.FC<IconProps> = ({ className, stroke }) => {
   return (
      <svg
         width="17"
         height="18"
         viewBox="0 0 17 18"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M0.833252 10H3.70825L6.58325 13H10.4166L13.2916 10H16.1666M2.74992 1H14.2499C15.3085 1 16.1666 1.89543 16.1666 3V15C16.1666 16.1046 15.3085 17 14.2499 17H2.74992C1.69137 17 0.833252 16.1046 0.833252 15V3C0.833252 1.89543 1.69137 1 2.74992 1Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </svg>
   );
};

export const Icon_CasesSent: React.FC<IconProps> = ({ className, stroke }) => {
   return (
      <svg
         width="20"
         height="21"
         viewBox="0 0 20 21"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M8.58322 12L19.1249 1M8.58322 12L11.9374 19C11.9794 19.0957 12.0469 19.1769 12.1319 19.2338C12.2168 19.2906 12.3156 19.3209 12.4166 19.3209C12.5175 19.3209 12.6163 19.2906 12.7012 19.2338C12.7862 19.1769 12.8537 19.0957 12.8957 19L19.1249 1M8.58322 12L1.87488 8.5C1.78313 8.45613 1.70538 8.38569 1.65087 8.29705C1.59636 8.20842 1.56738 8.10532 1.56738 8C1.56738 7.89468 1.59636 7.79158 1.65087 7.70295C1.70538 7.61431 1.78313 7.54387 1.87488 7.5L19.1249 1"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </svg>
   );
};
export const Icon_Plus2: React.FC<IconProps> = ({ fill }) => {
   return (
      <svg
         width="18"
         height="18"
         viewBox="0 0 18 18"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.1 0.75H7.9V7.9L0.75 7.9V10.1L7.9 10.1V17.25H10.1V10.1H17.25V7.9L10.1 7.9V0.75Z"
            fill={fill}
            opacity={1}
         />
      </svg>
   );
};

export const Icon_CasesTasks: React.FC<IconProps> = ({ className, stroke }) => {
   return (
      <svg
         width="17"
         height="18"
         viewBox="0 0 17 18"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M0.833496 9L8.50016 13L16.1668 9M0.833496 13L8.50016 17L16.1668 13M8.50016 1L0.833496 5L8.50016 9L16.1668 5L8.50016 1Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </svg>
   );
};

export const Icon_Warning: React.FC<IconProps> = ({ className, stroke, fill }) => {
   return (
      <svg
         width="1em"
         height="1em"
         viewBox="64 64 896 896"
         focusable="false"
         fill={fill}
         aria-hidden="true"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </svg>
   );
};

export const Icon_Archive: React.FC<IconProps> = ({ className }) => {
   return (
      <svg
         width="24"
         height="25"
         viewBox="0 0 24 25"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 5.72C4.30964 5.72 3.75 6.27965 3.75 6.97C3.75 7.66036 4.30964 8.22 5 8.22H19C19.6904 8.22 20.25 7.66036 20.25 6.97C20.25 6.27964 19.6904 5.72 19 5.72H5ZM2.25 6.97C2.25 5.45122 3.48122 4.22 5 4.22H19C20.5188 4.22 21.75 5.45122 21.75 6.97C21.75 8.22878 20.9043 9.29002 19.75 9.61649V18.97C19.75 19.6993 19.4603 20.3988 18.9445 20.9145C18.4288 21.4303 17.7293 21.72 17 21.72H7C6.27065 21.72 5.57118 21.4303 5.05546 20.9145C4.53973 20.3988 4.25 19.6993 4.25 18.97V9.61649C3.09575 9.29002 2.25 8.22878 2.25 6.97ZM5.75 9.72V18.97C5.75 19.3015 5.8817 19.6195 6.11612 19.8539C6.35054 20.0883 6.66848 20.22 7 20.22H17C17.3315 20.22 17.6495 20.0883 17.8839 19.8539C18.1183 19.6195 18.25 19.3015 18.25 18.97V9.72H5.75ZM9.25 12.97C9.25 12.5558 9.58579 12.22 10 12.22H14C14.4142 12.22 14.75 12.5558 14.75 12.97C14.75 13.3842 14.4142 13.72 14 13.72H10C9.58579 13.72 9.25 13.3842 9.25 12.97Z"
            fill="currentColor"
         />
      </svg>
   );
};

export const Icon_UserSettings: React.FC<IconProps> = ({ className, fill = "currentColor" }) => {
   return (
      <svg
         width="24"
         height="25"
         viewBox="0 0 24 25"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.34835 8.31834C10.0516 7.61508 11.0054 7.21999 12 7.21999C12.9946 7.21999 13.9484 7.61508 14.6517 8.31834C15.3549 9.0216 15.75 9.97543 15.75 10.97C15.75 11.9645 15.3549 12.9184 14.6517 13.6216C13.9484 14.3249 12.9946 14.72 12 14.72C11.0054 14.72 10.0516 14.3249 9.34835 13.6216C8.64509 12.9184 8.25 11.9645 8.25 10.97C8.25 9.97543 8.64509 9.0216 9.34835 8.31834ZM12 8.71999C11.4033 8.71999 10.831 8.95704 10.409 9.379C9.98705 9.80095 9.75 10.3733 9.75 10.97C9.75 11.5667 9.98705 12.139 10.409 12.561C10.831 12.9829 11.4033 13.22 12 13.22C12.5967 13.22 13.169 12.9829 13.591 12.561C14.0129 12.139 14.25 11.5667 14.25 10.97C14.25 10.3733 14.0129 9.80095 13.591 9.379C13.169 8.95704 12.5967 8.71999 12 8.71999Z"
            fill={fill}
         />
         <path
            d="M8.09572 18.3354C8.64988 17.9351 9.31615 17.7198 9.99975 17.72H14.0002C14.6834 17.7198 15.3493 17.9348 15.9032 18.3346L14 16.22H10C9.00097 16.2197 8.02729 16.5344 7.21743 17.1194C6.4075 17.7044 5.80265 18.5299 5.48893 19.4785C5.35887 19.8717 5.57224 20.296 5.9655 20.4261C6.35876 20.5561 6.783 20.3428 6.91307 19.9495C7.12772 19.3005 7.54156 18.7356 8.09572 18.3354Z"
            fill={fill}
         />
         <path
            d="M16.781 17.1183C15.9715 16.534 14.9984 16.2197 14 16.22L15.9032 18.3346C16.4572 18.7344 16.8711 19.2986 17.0861 19.9471C17.2165 20.3402 17.6409 20.5532 18.0341 20.4229C18.4272 20.2925 18.6403 19.8681 18.5099 19.4749C18.1956 18.5272 17.5907 17.7026 16.781 17.1183Z"
            fill={fill}
         />
         <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.2787 3.91208L4.53893 7.88604C4.53243 7.88988 4.52588 7.89361 4.51926 7.89725C4.04155 8.15982 3.75 8.65439 3.75 9.18699V16.4711C3.75065 16.7352 3.82217 16.9942 3.9571 17.2212C4.09215 17.4484 4.28575 17.6351 4.51766 17.7619C4.53168 17.7695 4.54545 17.7776 4.55895 17.7862L11.2874 22.0425C11.5067 22.159 11.7514 22.22 12 22.22C12.2486 22.22 12.4933 22.159 12.7126 22.0425L19.441 17.7862C19.454 17.7779 19.4673 17.7701 19.4807 17.7627C19.9581 17.5003 20.25 17.005 20.25 16.472V9.18333C20.2533 8.64954 19.9682 8.15575 19.5043 7.89197C19.4539 7.86329 19.4078 7.82943 19.3665 7.79136L12.7873 3.91208C12.5558 3.78631 12.2965 3.7204 12.033 3.7204C11.7695 3.7204 11.5102 3.78631 11.2787 3.91208ZM20.4316 6.70288C20.3893 6.66165 20.3416 6.62496 20.2889 6.59393L13.5389 2.61393C13.5327 2.61026 13.5264 2.60669 13.5201 2.6032C13.0647 2.35209 12.5531 2.2204 12.033 2.2204C11.5129 2.2204 11.0013 2.35209 10.5459 2.6032C10.5396 2.60669 10.5333 2.61026 10.5271 2.61393L3.78612 6.58859C2.84003 7.11356 2.25 8.10563 2.25 9.18699L2.25 16.4735C2.25107 17.0065 2.39534 17.5295 2.66772 17.9877C2.93572 18.4385 3.31805 18.8104 3.77582 19.0657L10.507 23.3238C10.5201 23.3321 10.5335 23.34 10.547 23.3474C10.9923 23.5919 11.492 23.72 12 23.72C12.508 23.72 13.0077 23.5919 13.453 23.3474C13.4665 23.34 13.4799 23.3321 13.493 23.3238L20.2249 19.0653C21.1649 18.5385 21.75 17.5488 21.75 16.472V9.19C21.7553 8.18797 21.2565 7.25558 20.4316 6.70288Z"
            fill={fill}
         />
      </svg>
   );
};
export const Icon_Calendar2: React.FC<IconProps> = ({ className, fill }) => {
   return (
      <svg
         className={className}
         width="16"
         height="17"
         viewBox="0 0 16 17"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <path
            d="M6.33827 3.04492V4.06685H9.41173V3.04492H10.4337V4.06685H12.4852C12.7695 4.06685 13 4.29736 13 4.58165V12.7801C13 13.0644 12.7695 13.2949 12.4852 13.2949H3.26481C2.98051 13.2949 2.75 13.0644 2.75 12.7801V4.58165C2.75 4.29736 2.98051 4.06685 3.26481 4.06685H5.31634V3.04492H6.33827ZM11.9704 8.16992H3.77193V12.2653H11.9704V8.16992ZM7.36019 9.19185V11.2434H4.80154V9.19185H7.36019ZM5.30866 5.09646H3.77193V7.148H11.9704V5.09646H10.4337V6.11839H9.41173V5.09646H6.33827V6.11839H5.31634V5.09646H5.30866Z"
            fill={fill || "#808080"}
         />
      </svg>
   );
};

export const Icon_Dot: React.FC<IconProps> = ({ className, fill, style }) => {
   return (
      <svg
         className={className}
         style={style}
         width="8"
         height="8"
         viewBox="0 0 8 8"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <circle cx="4" cy="4" r="4" fill={fill || "black"} />
      </svg>
   );
};

export const Icon_RenewSub: React.FC<IconProps> = ({ fill, lighterFill, className }) => {
   return (
      <svg
         width="214"
         height="211"
         viewBox="0 0 214 211"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <circle cx="112.5" cy="116.5" r="94.5" fill="white" />
         <ellipse cx="182.5" cy="181" rx="27.5" ry="28" fill="white" />
         <g filter="url(#filter0_d_325_2)">
            <path
               d="M179.08 68.0948H22.4077C20.4411 68.0948 18.8469 69.7016 18.8469 71.6836V174.413C18.8469 176.395 20.4411 178.001 22.4077 178.001H179.08C181.047 178.001 182.641 176.395 182.641 174.413V71.6836C182.641 69.7016 181.047 68.0948 179.08 68.0948Z"
               fill="url(#paint0_linear_325_2)"
            />
            <path
               d="M158.827 96.3595C180.336 96.3595 197.772 78.6852 197.772 56.8829C197.772 35.0805 180.336 17.4062 158.827 17.4062C137.318 17.4062 119.881 35.0805 119.881 56.8829C119.881 78.6852 137.318 96.3595 158.827 96.3595Z"
               fill="#FFFDE6"
            />
            <path
               d="M93.6222 90.5342H45.5522C43.8315 90.5342 42.4366 91.9401 42.4366 93.6744V108.927C42.4366 110.661 43.8315 112.067 45.5522 112.067H93.6222C95.3429 112.067 96.7378 110.661 96.7378 108.927V93.6744C96.7378 91.9401 95.3429 90.5342 93.6222 90.5342Z"
               fill="#FFFDEA"
            />
            <path
               d="M58.9062 146.606H45.9985C43.2945 146.606 41.1025 148.815 41.1025 151.54C41.1025 154.266 43.2945 156.475 45.9985 156.475H58.9062C61.6102 156.475 63.8022 154.266 63.8022 151.54C63.8022 148.815 61.6102 146.606 58.9062 146.606Z"
               fill="#FFFDEA"
            />
            <path
               d="M91.8424 146.606H78.4897C75.7857 146.606 73.5937 148.815 73.5937 151.54C73.5937 154.266 75.7857 156.475 78.4897 156.475H91.8424C94.5464 156.475 96.7385 154.266 96.7385 151.54C96.7385 148.815 94.5464 146.606 91.8424 146.606Z"
               fill="#FFFDEA"
            />
            <path
               d="M123.89 146.606H110.092C107.388 146.606 105.196 148.815 105.196 151.54C105.196 154.266 107.388 156.475 110.092 156.475H123.89C126.594 156.475 128.786 154.266 128.786 151.54C128.786 148.815 126.594 146.606 123.89 146.606Z"
               fill="#FFFDEA"
            />
            <path
               d="M155.94 146.606H143.033C140.329 146.606 138.137 148.815 138.137 151.54C138.137 154.266 140.329 156.475 143.033 156.475H155.94C158.644 156.475 160.836 154.266 160.836 151.54C160.836 148.815 158.644 146.606 155.94 146.606Z"
               fill="#FFFDEA"
            />
            <path
               d="M168.35 51.763H153.431V47.9239C153.431 46.4814 153.999 45.098 155.011 44.0781C156.023 43.0581 157.396 42.4851 158.827 42.4851C160.258 42.4851 161.631 43.0581 162.643 44.0781C163.655 45.098 164.223 46.4814 164.223 47.9239C164.215 48.0763 164.237 48.2288 164.289 48.3721C164.341 48.5155 164.422 48.6466 164.526 48.7576C164.63 48.8685 164.755 48.9569 164.894 49.0173C165.033 49.0776 165.183 49.1088 165.334 49.1088C165.486 49.1088 165.636 49.0776 165.775 49.0173C165.914 48.9569 166.039 48.8685 166.143 48.7576C166.247 48.6466 166.327 48.5155 166.379 48.3721C166.431 48.2288 166.454 48.0763 166.445 47.9239C166.442 46.9132 166.241 45.9132 165.853 44.981C165.466 44.0489 164.899 43.2031 164.187 42.492C163.474 41.781 162.629 41.2187 161.701 40.8374C160.772 40.4562 159.778 40.2635 158.775 40.2703C157.772 40.2772 156.781 40.4834 155.857 40.8773C154.934 41.2713 154.097 41.845 153.394 42.5657C152.691 43.2865 152.136 44.14 151.761 45.0773C151.386 46.0146 151.198 47.0174 151.208 48.028V51.763H149.304C148.463 51.7655 147.657 52.1033 147.062 52.7028C146.468 53.3023 146.132 54.1146 146.13 54.9624V70.3192C146.132 71.167 146.468 71.9793 147.062 72.5788C147.657 73.1783 148.463 73.5161 149.304 73.5186H168.35C169.191 73.5156 169.996 73.1774 170.591 72.578C171.185 71.9786 171.52 71.1666 171.522 70.3192V54.9624C171.52 54.115 171.185 53.303 170.591 52.7036C169.996 52.1042 169.191 51.7661 168.35 51.763ZM159.938 61.7443V67.2477C159.94 67.539 159.832 67.8201 159.636 68.0341C159.44 68.248 159.17 68.3787 158.882 68.3997C158.731 68.407 158.581 68.3835 158.439 68.3304C158.298 68.2774 158.169 68.1959 158.06 68.091C157.951 67.9861 157.864 67.86 157.805 67.7203C157.746 67.5806 157.715 67.4301 157.715 67.2782V61.7443C157.199 61.491 156.783 61.0687 156.535 60.5464C156.287 60.0241 156.223 59.4326 156.352 58.8685C156.481 58.3043 156.796 57.8009 157.245 57.4405C157.694 57.08 158.252 56.8837 158.826 56.8837C159.401 56.8837 159.958 57.08 160.407 57.4405C160.857 57.8009 161.172 58.3043 161.301 58.8685C161.43 59.4326 161.365 60.0241 161.117 60.5464C160.87 61.0687 160.454 61.491 159.937 61.7443H159.938Z"
               fill={fill}
            />
         </g>
         <defs>
            <filter
               id="filter0_d_325_2"
               x="17.8469"
               y="16.4062"
               width="186.926"
               height="168.595"
               filterUnits="userSpaceOnUse"
               color-interpolation-filters="sRGB"
            >
               <feFlood flood-opacity="0" result="BackgroundImageFix" />
               <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
               />
               <feOffset dx="3" dy="3" />
               <feGaussianBlur stdDeviation="2" />
               <feComposite in2="hardAlpha" operator="out" />
               <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.990385 0 0 0 0 0.990385 0 0 0 0 0.990385 0 0 0 1 0"
               />
               <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_325_2" />
               <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_325_2"
                  result="shape"
               />
            </filter>
            <linearGradient
               id="paint0_linear_325_2"
               x1="100.744"
               y1="68.0948"
               x2="100.744"
               y2="178.001"
               gradientUnits="userSpaceOnUse"
            >
               <stop stop-color={fill} />
               <stop offset="1" stop-color={lighterFill} />
            </linearGradient>
         </defs>
      </svg>
   );
};

export const Icon_NoData: React.FC<IconProps> = () => {
   return (
      <svg width="64" height="41" viewBox="0 0 64 41" xmlns="http://www.w3.org/2000/svg">
         <g transform="translate(0 1)" fill="none" fillRule="evenodd">
            <ellipse fill="#F5F5F5" cx="32" cy="33" rx="32" ry="7"></ellipse>
            <g fillRule="nonzero" stroke="#D9D9D9">
               <path d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"></path>
               <path
                  d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z"
                  fill="#FAFAFA"
               ></path>
            </g>
         </g>
      </svg>
   );
};

export const Icon_CalendarWithClock: React.FC<IconProps> = ({ className, fill }) => {
   return (
      <svg
         width="14"
         height="14"
         viewBox="0 0 14 14"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <g clip-path="url(#clip0_1326_498)">
            <path
               d="M10.5547 6.28906C10.8567 6.28906 11.1016 6.04422 11.1016 5.74219C11.1016 5.44016 10.8567 5.19531 10.5547 5.19531C10.2527 5.19531 10.0078 5.44016 10.0078 5.74219C10.0078 6.04422 10.2527 6.28906 10.5547 6.28906Z"
               fill="#585858"
            />
            <path
               d="M11.8125 1.09375H11.1016V0.546875C11.1016 0.244836 10.8567 0 10.5547 0C10.2526 0 10.0078 0.244836 10.0078 0.546875V1.09375H7.51953V0.546875C7.51953 0.244836 7.2747 0 6.97266 0C6.67062 0 6.42578 0.244836 6.42578 0.546875V1.09375H3.96484V0.546875C3.96484 0.244836 3.72001 0 3.41797 0C3.11593 0 2.87109 0.244836 2.87109 0.546875V1.09375H2.1875C0.981313 1.09375 0 2.07506 0 3.28125V11.8125C0 13.0187 0.981313 14 2.1875 14H6.37109C6.67313 14 6.91797 13.7552 6.91797 13.4531C6.91797 13.1511 6.67313 12.9062 6.37109 12.9062H2.1875C1.58441 12.9062 1.09375 12.4156 1.09375 11.8125V3.28125C1.09375 2.67816 1.58441 2.1875 2.1875 2.1875H2.87109V2.73438C2.87109 3.03641 3.11593 3.28125 3.41797 3.28125C3.72001 3.28125 3.96484 3.03641 3.96484 2.73438V2.1875H6.42578V2.73438C6.42578 3.03641 6.67062 3.28125 6.97266 3.28125C7.2747 3.28125 7.51953 3.03641 7.51953 2.73438V2.1875H10.0078V2.73438C10.0078 3.03641 10.2526 3.28125 10.5547 3.28125C10.8567 3.28125 11.1016 3.03641 11.1016 2.73438V2.1875H11.8125C12.4156 2.1875 12.9062 2.67816 12.9062 3.28125V6.39844C12.9062 6.70048 13.1511 6.94531 13.4531 6.94531C13.7552 6.94531 14 6.70048 14 6.39844V3.28125C14 2.07506 13.0187 1.09375 11.8125 1.09375Z"
               fill="#585858"
            />
            <path
               d="M10.6914 7.38281C8.86703 7.38281 7.38281 8.86703 7.38281 10.6914C7.38281 12.5158 8.86703 14 10.6914 14C12.5158 14 14 12.5158 14 10.6914C14 8.86703 12.5158 7.38281 10.6914 7.38281ZM10.6914 12.9062C9.47015 12.9062 8.47656 11.9127 8.47656 10.6914C8.47656 9.47012 9.47015 8.47656 10.6914 8.47656C11.9127 8.47656 12.9062 9.47012 12.9062 10.6914C12.9062 11.9127 11.9127 12.9062 10.6914 12.9062Z"
               fill="#585858"
            />
            <path
               d="M11.4844 10.1445H11.2383V9.57031C11.2383 9.26827 10.9934 9.02344 10.6914 9.02344C10.3894 9.02344 10.1445 9.26827 10.1445 9.57031V10.6914C10.1445 10.9934 10.3894 11.2383 10.6914 11.2383H11.4844C11.7864 11.2383 12.0312 10.9934 12.0312 10.6914C12.0312 10.3894 11.7864 10.1445 11.4844 10.1445Z"
               fill="#585858"
            />
            <path
               d="M8.17578 6.28906C8.47781 6.28906 8.72266 6.04422 8.72266 5.74219C8.72266 5.44016 8.47781 5.19531 8.17578 5.19531C7.87375 5.19531 7.62891 5.44016 7.62891 5.74219C7.62891 6.04422 7.87375 6.28906 8.17578 6.28906Z"
               fill="#585858"
            />
            <path
               d="M5.79688 8.66797C6.09891 8.66797 6.34375 8.42312 6.34375 8.12109C6.34375 7.81906 6.09891 7.57422 5.79688 7.57422C5.49484 7.57422 5.25 7.81906 5.25 8.12109C5.25 8.42312 5.49484 8.66797 5.79688 8.66797Z"
               fill="#585858"
            />
            <path
               d="M3.41797 6.28906C3.72 6.28906 3.96484 6.04422 3.96484 5.74219C3.96484 5.44016 3.72 5.19531 3.41797 5.19531C3.11594 5.19531 2.87109 5.44016 2.87109 5.74219C2.87109 6.04422 3.11594 6.28906 3.41797 6.28906Z"
               fill="#585858"
            />
            <path
               d="M3.41797 8.66797C3.72 8.66797 3.96484 8.42312 3.96484 8.12109C3.96484 7.81906 3.72 7.57422 3.41797 7.57422C3.11594 7.57422 2.87109 7.81906 2.87109 8.12109C2.87109 8.42312 3.11594 8.66797 3.41797 8.66797Z"
               fill="#585858"
            />
            <path
               d="M3.41797 11.0469C3.72 11.0469 3.96484 10.802 3.96484 10.5C3.96484 10.198 3.72 9.95312 3.41797 9.95312C3.11594 9.95312 2.87109 10.198 2.87109 10.5C2.87109 10.802 3.11594 11.0469 3.41797 11.0469Z"
               fill="#585858"
            />
            <path
               d="M5.79688 11.0469C6.09891 11.0469 6.34375 10.802 6.34375 10.5C6.34375 10.198 6.09891 9.95312 5.79688 9.95312C5.49484 9.95312 5.25 10.198 5.25 10.5C5.25 10.802 5.49484 11.0469 5.79688 11.0469Z"
               fill="#585858"
            />
            <path
               d="M5.79688 6.28906C6.09891 6.28906 6.34375 6.04422 6.34375 5.74219C6.34375 5.44016 6.09891 5.19531 5.79688 5.19531C5.49484 5.19531 5.25 5.44016 5.25 5.74219C5.25 6.04422 5.49484 6.28906 5.79688 6.28906Z"
               fill="#585858"
            />
         </g>
         <defs>
            <clipPath id="clip0_1326_498">
               <rect width="14" height="14" fill="white" />
            </clipPath>
         </defs>
      </svg>
   );
};

export const Icon_MapMarker: React.FC<IconProps> = ({ className, fill = "#fff" }) => (
   <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
   >
      <path
         fillRule="evenodd"
         clipRule="evenodd"
         d="M11 3.84515C14.0091 3.84515 16.4485 6.28446 16.4485 9.29361C16.4485 12.3027 11 18.1548 11 18.1548C11 18.1548 5.55154 12.3027 5.55154 9.29361C5.55154 6.28446 7.99085 3.84515 11 3.84515ZM11 7.12887C12.1409 7.12887 13.0661 8.05408 13.0661 9.19505C13.0661 10.3359 12.1409 11.2611 11 11.2611C9.85912 11.2611 8.93391 10.3359 8.93391 9.19505C8.93391 8.05408 9.85912 7.12887 11 7.12887Z"
         fill={fill}
      />
   </svg>
);

export const Icon_NIP: React.FC<IconProps> = ({ className, fill }) => {
   return (
      <svg
         width="12"
         height="12"
         viewBox="0 0 12 12"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M9.5 0.5H2.5C2.38019 0.501379 2.26486 0.545738 2.175 0.625C2.53157 0.750451 2.84529 0.974379 3.0798 1.27083C3.3143 1.56729 3.46 1.92413 3.5 2.3C3.50764 2.36645 3.50764 2.43355 3.5 2.5V11C3.49976 11.0956 3.52696 11.1893 3.57836 11.27C3.62976 11.3506 3.70321 11.4148 3.79 11.455C3.87699 11.495 3.97366 11.5093 4.0685 11.496C4.16334 11.4827 4.25237 11.4424 4.325 11.38L5.75 10.16L7.175 11.38C7.26557 11.4575 7.38082 11.5 7.5 11.5C7.61918 11.5 7.73443 11.4575 7.825 11.38L9.25 10.16L10.675 11.38C10.7656 11.4575 10.8808 11.5 11 11.5C11.0723 11.4995 11.1438 11.4842 11.21 11.455C11.2968 11.4148 11.3702 11.3506 11.4216 11.27C11.473 11.1893 11.5002 11.0956 11.5 11V2.5C11.5 1.96957 11.2893 1.46086 10.9142 1.08579C10.5391 0.710714 10.0304 0.5 9.5 0.5ZM9 7.5H6C5.86739 7.5 5.74021 7.44732 5.64645 7.35355C5.55268 7.25979 5.5 7.13261 5.5 7C5.5 6.86739 5.55268 6.74021 5.64645 6.64645C5.74021 6.55268 5.86739 6.5 6 6.5H9C9.13261 6.5 9.25979 6.55268 9.35355 6.64645C9.44732 6.74021 9.5 6.86739 9.5 7C9.5 7.13261 9.44732 7.25979 9.35355 7.35355C9.25979 7.44732 9.13261 7.5 9 7.5ZM9 5.5H6C5.86739 5.5 5.74021 5.44732 5.64645 5.35355C5.55268 5.25979 5.5 5.13261 5.5 5C5.5 4.86739 5.55268 4.74021 5.64645 4.64645C5.74021 4.55268 5.86739 4.5 6 4.5H9C9.13261 4.5 9.25979 4.55268 9.35355 4.64645C9.44732 4.74021 9.5 4.86739 9.5 5C9.5 5.13261 9.44732 5.25979 9.35355 5.35355C9.25979 5.44732 9.13261 5.5 9 5.5ZM9 3.5H6C5.86739 3.5 5.74021 3.44732 5.64645 3.35355C5.55268 3.25979 5.5 3.13261 5.5 3C5.5 2.86739 5.55268 2.74021 5.64645 2.64645C5.74021 2.55268 5.86739 2.5 6 2.5H9C9.13261 2.5 9.25979 2.55268 9.35355 2.64645C9.44732 2.74021 9.5 2.86739 9.5 3C9.5 3.13261 9.44732 3.25979 9.35355 3.35355C9.25979 3.44732 9.13261 3.5 9 3.5ZM2.5 2.5V6.5H1C0.867392 6.5 0.740215 6.44732 0.646447 6.35355C0.552678 6.25979 0.5 6.13261 0.5 6V2.3C0.526522 2.03478 0.657314 1.79097 0.863604 1.62218C1.06989 1.4534 1.33478 1.37348 1.6 1.4C1.86522 1.42652 2.10903 1.55731 2.27782 1.7636C2.4466 1.96989 2.52652 2.23478 2.5 2.5Z"
            fill={fill || "#fff"}
         />
      </svg>
   );
};

export const Icon_ConversationTopic: React.FC<IconProps> = ({ className, fill }) => {
   return (
      <svg
         width="14"
         height="12"
         viewBox="0 0 14 12"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.22916 7.91158C4.21915 7.9165 4.20976 7.92257 4.20116 7.92967L2.61332 9.25267C2.54952 9.30612 2.47178 9.34023 2.38925 9.351C2.30671 9.36176 2.22282 9.34873 2.14744 9.31343C2.07207 9.27813 2.00834 9.22204 1.96376 9.15175C1.91919 9.08146 1.89562 8.9999 1.89582 8.91667V7.83517C1.56011 7.7395 1.26467 7.53713 1.05419 7.25866C0.843697 6.98018 0.729604 6.64074 0.729156 6.29167V1.91667C0.729156 1.49142 0.898323 1.08308 1.19874 0.782083C1.49987 0.481547 1.90788 0.312679 2.33332 0.3125H7.58332C8.00857 0.3125 8.41691 0.481667 8.71791 0.782083C9.01832 1.08308 9.18749 1.49142 9.18749 1.91667V2.0625H6.41666C5.83659 2.06281 5.28037 2.29338 4.8702 2.70355C4.46003 3.11371 4.22947 3.66993 4.22916 4.25V7.91158Z"
            fill="white"
         />
         <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.8125 4.24999C4.8125 3.82474 4.98167 3.41641 5.28208 3.11541C5.58321 2.81488 5.99122 2.64601 6.41667 2.64583H11.6667C12.0919 2.64583 12.5002 2.81499 12.8012 3.11541C13.1017 3.41641 13.2708 3.82474 13.2708 4.24999V8.62499C13.2704 8.97407 13.1563 9.31351 12.9458 9.59199C12.7353 9.87046 12.4399 10.0728 12.1042 10.1685V11.25C12.1044 11.3332 12.0808 11.4148 12.0362 11.4851C11.9916 11.5554 11.9279 11.6115 11.8525 11.6468C11.7772 11.6821 11.6933 11.6951 11.6107 11.6843C11.5282 11.6736 11.4505 11.6394 11.3867 11.586L9.79883 10.263C9.77254 10.2413 9.73958 10.2294 9.7055 10.2292H6.41667C5.99142 10.2292 5.58308 10.06 5.28208 9.75958C4.98155 9.45845 4.81268 9.05044 4.8125 8.62499V4.24999ZM7.58333 5.85416H9.33333C9.44937 5.85416 9.56065 5.80807 9.64269 5.72602C9.72474 5.64397 9.77083 5.53269 9.77083 5.41666C9.77083 5.30063 9.72474 5.18935 9.64269 5.1073C9.56065 5.02526 9.44937 4.97916 9.33333 4.97916H7.58333C7.4673 4.97916 7.35602 5.02526 7.27397 5.1073C7.19193 5.18935 7.14583 5.30063 7.14583 5.41666C7.14583 5.53269 7.19193 5.64397 7.27397 5.72602C7.35602 5.80807 7.4673 5.85416 7.58333 5.85416ZM7.58333 7.60416H10.5C10.616 7.60416 10.7273 7.55807 10.8094 7.47602C10.8914 7.39397 10.9375 7.28269 10.9375 7.16666C10.9375 7.05063 10.8914 6.93935 10.8094 6.8573C10.7273 6.77526 10.616 6.72916 10.5 6.72916H7.58333C7.4673 6.72916 7.35602 6.77526 7.27397 6.8573C7.19193 6.93935 7.14583 7.05063 7.14583 7.16666C7.14583 7.28269 7.19193 7.39397 7.27397 7.47602C7.35602 7.55807 7.4673 7.60416 7.58333 7.60416Z"
            fill="white"
         />
      </svg>
   );
};

export const Icon_PhoneCallUser: React.FC<IconProps> = ({ className, fill, lighterFill }) => {
   return (
      <svg
         width="14"
         height="14"
         viewBox="0 0 14 14"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M7.00096 7.26985C9.00098 7.26985 10.6359 5.63494 10.6359 3.63493C10.6359 1.63491 9.00098 0 7.00096 0C5.00095 0 3.36607 1.63491 3.36607 3.63493C3.36607 5.63494 5.00098 7.26985 7.00096 7.26985ZM13.2391 10.1746C13.1438 9.93651 13.0169 9.71429 12.874 9.50794C12.1438 8.42856 11.0169 7.71428 9.74704 7.53967C9.58832 7.52382 9.41371 7.55553 9.28672 7.65078C8.62005 8.14285 7.82641 8.39681 7.00099 8.39681C6.17558 8.39681 5.38194 8.14285 4.71527 7.65078C4.58827 7.55553 4.41367 7.50793 4.25495 7.53967C2.98511 7.71428 1.84226 8.42856 1.12798 9.50794C0.985125 9.71429 0.858128 9.9524 0.762911 10.1746C0.715303 10.2699 0.731162 10.381 0.77877 10.4762C0.905767 10.6984 1.06448 10.9207 1.20734 11.1111C1.42955 11.4127 1.66765 11.6826 1.93751 11.9365C2.15972 12.1587 2.41368 12.3651 2.66768 12.5714C3.92163 13.508 5.42958 14 6.98513 14C8.54069 14 10.0486 13.5079 11.3026 12.5714C11.5566 12.381 11.8105 12.1587 12.0328 11.9365C12.2867 11.6826 12.5407 11.4127 12.7629 11.1111C12.9216 10.9048 13.0645 10.6984 13.1915 10.4762C13.2708 10.381 13.2867 10.2698 13.2391 10.1746Z"
            fill={fill || "#fff"}
         />
      </svg>
   );
};

export const Icon_AddNote: React.FC<IconProps> = ({ className, fill }) => {
   return (
      <svg
         width="16"
         height="16"
         viewBox="0 0 16 16"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M0.640015 2.30401V13.632C0.640015 14.72 1.53601 15.616 2.62401 15.616H11.136C12.224 15.616 13.12 14.72 13.12 13.632V10.88L12.672 11.328C12.224 11.776 11.584 12.096 10.944 12.288L9.60001 12.544C9.02401 12.672 8.38401 12.48 8.06401 12.032C7.74401 11.648 7.61601 11.2 7.74401 10.688L8.06401 9.28001C8.19201 8.64001 8.51201 8.06401 9.02401 7.55201L12.224 4.35201C12.48 4.09601 12.864 3.84001 13.184 3.71201V2.30401C13.184 1.21601 12.288 0.320007 11.2 0.320007H2.62401C1.53601 0.320007 0.640015 1.21601 0.640015 2.30401ZM3.77601 2.56001H9.92001C10.304 2.56001 10.56 2.81601 10.56 3.20001C10.56 3.58401 10.304 3.84001 9.92001 3.84001H3.77601C3.39201 3.84001 3.13601 3.58401 3.13601 3.20001C3.13601 2.88001 3.45601 2.56001 3.77601 2.56001ZM3.77601 5.18401H7.36001C7.74401 5.18401 8.00001 5.44001 8.00001 5.82401C8.00001 6.20801 7.74401 6.46401 7.36001 6.46401H3.77601C3.39201 6.46401 3.13601 6.20801 3.13601 5.82401C3.13601 5.44001 3.45601 5.18401 3.77601 5.18401Z"
            fill={fill || "#333333"}
         />
         <path
            d="M14.976 5.31201C14.464 4.80001 13.568 4.80001 13.056 5.31201L9.856 8.51201C9.536 8.83201 9.344 9.15201 9.28 9.60001L8.96 10.944C8.896 11.136 9.088 11.328 9.28 11.264L10.688 10.944C11.072 10.88 11.456 10.624 11.776 10.368L14.976 7.16801C15.488 6.65601 15.488 5.82401 14.976 5.31201Z"
            fill={fill || "#333333"}
         />
      </svg>
   );
};

export const Icon_Details: React.FC<IconProps> = ({ className, fill }) => {
   return (
      <svg
         width="16"
         height="16"
         viewBox="0 0 16 16"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.2 3.2V2.4C3.2 1.76348 3.45286 1.15303 3.90294 0.702944C4.35303 0.252856 4.96348 0 5.6 0H13.6C14.2365 0 14.847 0.252856 15.2971 0.702944C15.7471 1.15303 16 1.76348 16 2.4V10.4C16 11.0365 15.7471 11.647 15.2971 12.0971C14.847 12.5471 14.2365 12.8 13.6 12.8H12.8V13.6C12.8 14.2365 12.5471 14.847 12.0971 15.2971C11.647 15.7471 11.0365 16 10.4 16H2.4C1.76348 16 1.15303 15.7471 0.702944 15.2971C0.252856 14.847 0 14.2365 0 13.6V5.6C0 4.96348 0.252856 4.35303 0.702944 3.90294C1.15303 3.45286 1.76348 3.2 2.4 3.2H3.2ZM4.8 3.2V2.4C4.8 2.18783 4.88429 1.98434 5.03431 1.83431C5.18434 1.68429 5.38783 1.6 5.6 1.6H13.6C13.8122 1.6 14.0157 1.68429 14.1657 1.83431C14.3157 1.98434 14.4 2.18783 14.4 2.4V10.4C14.4 10.6122 14.3157 10.8157 14.1657 10.9657C14.0157 11.1157 13.8122 11.2 13.6 11.2H12.8V5.6C12.8 4.96348 12.5471 4.35303 12.0971 3.90294C11.647 3.45286 11.0365 3.2 10.4 3.2H4.8Z"
            fill={fill || "#333333"}
         />
      </svg>
   );
};

export const Icon_AddTask: React.FC<IconProps> = ({ className, fill }) => {
   return (
      <svg
         width="16"
         height="16"
         viewBox="0 0 16 16"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M11.8215 0.447754H3.85015C2.94857 0.450319 2.08464 0.809608 1.44713 1.44713C0.809608 2.08464 0.450319 2.94857 0.447754 3.85015L0.447754 11.8215C0.450319 12.7231 0.809608 13.587 1.44713 14.2245C2.08464 14.862 2.94857 15.2213 3.85015 15.2239H11.8215C12.7231 15.2213 13.587 14.862 14.2245 14.2245C14.862 13.587 15.2213 12.7231 15.2239 11.8215V3.85015C15.2213 2.94857 14.862 2.08464 14.2245 1.44713C13.587 0.809608 12.7231 0.450319 11.8215 0.447754ZM10.8698 8.47255H8.62711C8.60984 8.47242 8.59272 8.47572 8.57674 8.48227C8.56076 8.48882 8.54624 8.49848 8.53403 8.5107C8.52182 8.52291 8.51215 8.53743 8.5056 8.55341C8.49905 8.56939 8.49575 8.58651 8.49588 8.60378V10.8494C8.49588 11.0244 8.42634 11.1923 8.30255 11.3161C8.17876 11.4399 8.01087 11.5094 7.83581 11.5094C7.66075 11.5094 7.49286 11.4399 7.36908 11.3161C7.24529 11.1923 7.17575 11.0244 7.17575 10.8494V8.60378C7.17588 8.58651 7.17257 8.56939 7.16602 8.55341C7.15947 8.53743 7.14981 8.52291 7.1376 8.5107C7.12539 8.49848 7.11087 8.48882 7.09489 8.48227C7.07891 8.47572 7.06178 8.47242 7.04451 8.47255H4.80185C4.71517 8.47255 4.62934 8.45547 4.54925 8.4223C4.46917 8.38913 4.3964 8.34051 4.33511 8.27922C4.27382 8.21793 4.2252 8.14516 4.19203 8.06508C4.15886 7.985 4.14178 7.89916 4.14178 7.81248C4.14178 7.7258 4.15886 7.63997 4.19203 7.55989C4.2252 7.4798 4.27382 7.40704 4.33511 7.34575C4.3964 7.28445 4.46917 7.23583 4.54925 7.20266C4.62934 7.16949 4.71517 7.15242 4.80185 7.15242H7.04451C7.06178 7.15255 7.07891 7.14924 7.09489 7.14269C7.11087 7.13614 7.12539 7.12648 7.1376 7.11427C7.14981 7.10206 7.15947 7.08754 7.16602 7.07156C7.17257 7.05558 7.17588 7.03845 7.17575 7.02118V4.77852C7.17575 4.60346 7.24529 4.43557 7.36908 4.31178C7.49286 4.188 7.66075 4.11845 7.83581 4.11845C8.01087 4.11845 8.17876 4.188 8.30255 4.31178C8.42634 4.43557 8.49588 4.60346 8.49588 4.77852V7.02118C8.49535 7.0387 8.49837 7.05613 8.50474 7.07245C8.51111 7.08878 8.52071 7.10364 8.53297 7.11617C8.54522 7.12869 8.55987 7.13862 8.57605 7.14535C8.59223 7.15208 8.60959 7.15547 8.62711 7.15533H10.8698C11.0448 7.15533 11.2127 7.22488 11.3365 7.34866C11.4603 7.47245 11.5298 7.64034 11.5298 7.8154C11.5298 7.99046 11.4603 8.15835 11.3365 8.28214C11.2127 8.40592 11.0448 8.47546 10.8698 8.47546V8.47255Z"
            fill={fill || "#333333"}
         />
      </svg>
   );
};

export const Icon_Reschedule: React.FC<IconProps> = ({ className, fill }) => {
   return (
      <svg
         width="16"
         height="16"
         viewBox="0 0 16 16"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M8 16C12.4171 16 16 12.4171 16 8C16 3.58285 12.4171 0 8 0C3.58285 0 0 3.58285 0 8C0 12.4171 3.58285 16 8 16ZM7.42855 3.42858C7.42855 3.11428 7.6857 2.85713 8 2.85713C8.3143 2.85713 8.57144 3.11428 8.57144 3.42858V7.72572L11.2143 9.84001C11.46 10.0372 11.5 10.3971 11.3029 10.6429C11.2495 10.7098 11.1817 10.7639 11.1045 10.801C11.0273 10.8381 10.9428 10.8573 10.8571 10.8571C10.7314 10.8571 10.6057 10.8171 10.5 10.7314L7.64288 8.44573C7.50859 8.33714 7.4286 8.1743 7.4286 8V3.42858H7.42855Z"
            fill={fill || "#333333"}
         />
      </svg>
   );
};

export const Icon_AddTelephone: React.FC<IconProps> = ({ className, fill }) => {
   return (
      <svg
         width="24"
         height="24"
         viewBox="0 0 24 24"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <rect x="23" y="11" width="2" height="22" transform="rotate(90 23 11)" fill="#333333" />
         <rect x="11" y="1" width="2" height="22" fill="#333333" />
      </svg>
   );
};

export const Icon_OnHold: React.FC<IconProps> = ({ className, fill }) => {
   return (
      <svg
         width="20"
         height="20"
         viewBox="0 0 24 24"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <rect x="4" y="2" width="3" height="20" fill="#333333" />
         <rect x="17" y="2" width="3" height="20" fill="#333333" />
      </svg>
   );
};

export const Icon_Bluetooth: React.FC<IconProps> = ({ className, fill }) => {
   return (
      <svg
         width="22"
         height="24"
         viewBox="0 0 22 24"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M20.036 5.65801L18.518 7.17603C19.268 8.62199 19.7 10.26 19.7 12.006C19.7 13.752 19.268 15.384 18.518 16.836L19.958 18.276C21.116 16.416 21.8 14.238 21.8 11.898C21.8 9.60597 21.146 7.47601 20.036 5.65801ZM15.446 6.84601L8.60001 0H7.40003V9.10197L1.898 3.6L0.199982 5.29801L6.902 12L0.199982 18.702L1.898 20.4L7.39998 14.898V24H8.59996L15.446 17.154L10.298 12L15.446 6.84601ZM9.79999 4.59602L12.056 6.85203L9.79999 9.10203V4.59602ZM12.056 17.154L9.79999 19.404V14.892L12.056 17.154Z"
            fill="#333333"
         />
         <path
            d="M13.688 12.012L16.472 14.796C16.8079 13.926 17 12.984 17 12C17 11.022 16.814 10.086 16.484 9.22198L13.688 12.012Z"
            fill="#333333"
         />
      </svg>
   );
};

export const Icon_Speaker: React.FC<IconProps> = ({ className, fill }) => {
   return (
      <svg
         width="24"
         height="22"
         viewBox="0 0 24 22"
         fill={fill}
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M3.35218 7.2679H0V14.7321H3.35218L9.6862 19.4296C9.6862 19.4296 10.8479 20.4039 10.8479 19.3981V2.45592C10.8479 1.66609 9.82604 2.43748 9.82604 2.43748L3.35218 7.2679ZM14.4567 5.81117C14.3777 5.73191 14.2838 5.66902 14.1804 5.62611C14.0771 5.5832 13.9663 5.56111 13.8543 5.56111C13.7424 5.56111 13.6316 5.5832 13.5282 5.62611C13.4249 5.66902 13.331 5.73191 13.252 5.81117C13.1723 5.88998 13.1091 5.98379 13.066 6.08718C13.0228 6.19058 13.0006 6.3015 13.0006 6.41353C13.0006 6.52557 13.0228 6.63649 13.066 6.73988C13.1091 6.84328 13.1723 6.93709 13.252 7.01589C13.7728 7.53578 14.1859 8.15344 14.4674 8.83339C14.7489 9.51334 14.8933 10.2422 14.8923 10.9781C14.8941 11.7152 14.7501 12.4453 14.4686 13.1265C14.1871 13.8077 13.7736 14.4265 13.252 14.9473C13.1321 15.0664 13.0504 15.2186 13.0172 15.3843C12.984 15.55 13.0007 15.7218 13.0654 15.878C13.13 16.0342 13.2396 16.1676 13.3802 16.2614C13.5208 16.3552 13.6861 16.4051 13.8551 16.4048C14.071 16.4048 14.29 16.3233 14.4567 16.1558C15.1362 15.4758 15.675 14.6685 16.0421 13.78C16.4093 12.8916 16.5977 11.9394 16.5965 10.9781C16.5983 10.0183 16.4101 9.06761 16.0429 8.18083C15.6757 7.29404 15.1366 6.48869 14.4567 5.81117Z"
            fill={fill}
         />
         <path
            d="M16.7678 3.12586C16.6887 3.04623 16.5946 2.98303 16.4909 2.9399C16.3873 2.89677 16.2762 2.87457 16.1639 2.87457C16.0516 2.87457 15.9405 2.89677 15.8369 2.9399C15.7332 2.98303 15.6391 3.04623 15.56 3.12586C15.4014 3.28685 15.3125 3.50377 15.3125 3.72976C15.3125 3.95575 15.4014 4.17267 15.56 4.33366C16.4362 5.2055 17.1314 6.24198 17.6055 7.38347C18.0797 8.52497 18.3235 9.74894 18.3229 10.985C18.3248 12.2264 18.0818 13.456 17.6077 14.6033C17.1336 15.7506 16.4377 16.793 15.56 17.6709C15.4009 17.8314 15.3117 18.0481 15.3117 18.274C15.3117 18.5 15.4009 18.7167 15.56 18.8772C15.7283 19.0401 15.9457 19.1246 16.1647 19.1246C16.3821 19.1246 16.6011 19.0401 16.7678 18.8772C17.8031 17.8405 18.6239 16.6098 19.1832 15.2556C19.7424 13.9014 20.0292 12.4502 20.027 10.985C20.027 8.14375 18.9352 5.29559 16.7678 3.12586Z"
            fill={fill}
         />
         <path
            d="M19.5983 0.375302C19.5193 0.295716 19.4253 0.232549 19.3218 0.189443C19.2183 0.146338 19.1073 0.124146 18.9952 0.124146C18.883 0.124146 18.772 0.146338 18.6685 0.189443C18.565 0.232549 18.471 0.295716 18.392 0.375302C18.2332 0.535578 18.1442 0.75206 18.1442 0.977665C18.1442 1.20327 18.2332 1.41975 18.392 1.58003C19.6307 2.81339 20.6131 4.27962 21.2827 5.89428C21.9523 7.50893 22.2958 9.24011 22.2935 10.9881C22.2935 14.4064 20.9982 17.8139 18.392 20.4215C18.2326 20.5818 18.1431 20.7986 18.1431 21.0247C18.1431 21.2507 18.2326 21.4675 18.392 21.6278C18.5603 21.793 18.7793 21.8752 18.9982 21.8752C19.2141 21.8752 19.4316 21.793 19.5983 21.6278C20.9962 20.2312 22.1047 18.5724 22.86 16.7464C23.6154 14.9205 24.0028 12.9634 24 10.9873C24.0008 7.14958 22.5271 3.30414 19.5983 0.375302Z"
            fill={fill}
         />
      </svg>
   );
};

export const Icon_HangUpPhoneCall: React.FC<IconProps> = ({ className, fill }) => {
   return (
      <svg
         width="22"
         height="13"
         viewBox="0 0 27 13"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M0.866201 9.40627C0.649026 8.97068 0.554259 8.48428 0.592024 7.99903C0.629789 7.51377 0.798667 7.04789 1.08062 6.65114C2.46135 4.62669 4.31281 2.9676 6.47603 1.81636C8.63924 0.665125 11.0496 0.056134 13.5 0.041687C15.9504 0.056134 18.3607 0.665125 20.524 1.81636C22.6872 2.9676 24.5386 4.62669 25.9194 6.65114C26.2015 7.04776 26.3706 7.51359 26.4086 7.99885C26.4466 8.48411 26.3521 8.97057 26.1351 9.40627L24.7362 12.2182C24.6587 12.3751 24.551 12.5152 24.4192 12.6303C24.2873 12.7453 24.1341 12.8332 23.9681 12.8888C23.8022 12.9444 23.6269 12.9666 23.4524 12.9541C23.2778 12.9417 23.1075 12.8948 22.9511 12.8163L19.5553 11.11C19.3341 10.9982 19.1482 10.8272 19.0184 10.6161C18.8886 10.4049 18.8201 10.1618 18.8204 9.91389L18.6667 6.50002C18.6667 6.50002 17.4912 4.0536 13.5 4.0536C9.50874 4.0536 8.33333 6.50002 8.33333 6.50002L8.17833 9.91389C8.17874 10.1616 8.11037 10.4046 7.98084 10.6158C7.8513 10.827 7.66568 10.9981 7.44466 11.11L4.04758 12.8176C3.89126 12.8957 3.72106 12.9421 3.54674 12.9543C3.37241 12.9664 3.19741 12.944 3.03177 12.8883C2.86614 12.8326 2.71314 12.7448 2.58157 12.6298C2.44999 12.5148 2.34244 12.3749 2.26508 12.2182L0.866201 9.40627Z"
            fill="white"
         />
      </svg>
   );
};

export const Icon_MuteMicrophone: React.FC<IconProps> = ({ className, fill }) => {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         height="24px"
         viewBox="0 -960 960 960"
         width="24px"
         fill={fill}
      >
         <path d="m710-362-58-58q14-23 21-48t7-52h80q0 44-13 83.5T710-362ZM480-594Zm112 112-72-72v-206q0-17-11.5-28.5T480-800q-17 0-28.5 11.5T440-760v126l-80-80v-46q0-50 35-85t85-35q50 0 85 35t35 85v240q0 11-2.5 20t-5.5 18ZM440-120v-123q-104-14-172-93t-68-184h80q0 83 57.5 141.5T480-320q34 0 64.5-10.5T600-360l57 57q-29 23-63.5 39T520-243v123h-80Zm352 64L56-792l56-56 736 736-56 56Z" />
      </svg>
   );
};

export const Icon_SwapCalls: React.FC<IconProps> = ({ className, fill }) => {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         height="24px"
         viewBox="0 -960 960 960"
         width="24px"
         fill="#1f1f1f"
      >
         <path d="M240-200 80-360l56-58 64 64v-286q0-66 47-113t113-47q66 0 113 47t47 113v280q0 33 23.5 56.5T600-280q33 0 56.5-23.5T680-360v-286l-64 64-56-58 160-160 160 160-56 58-64-64v286q0 66-47 113t-113 47q-66 0-113-47t-47-113v-280q0-33-23.5-56.5T360-720q-33 0-56.5 23.5T280-640v286l64-64 56 58-160 160Z" />
      </svg>
   );
};

export const Icon_MergeCalls: React.FC<IconProps> = ({ className, fill }) => {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         height="24px"
         viewBox="0 -960 960 960"
         width="24px"
         fill="#1f1f1f"
      >
         <path d="m296-160-56-56 200-200v-269L337-582l-57-57 200-200 201 201-57 57-104-104v301L296-160Zm368 1L536-286l57-57 127 128-56 56Z" />
      </svg>
   );
};

export const Icon_AddUserToCall: React.FC<IconProps> = ({ className, fill }) => {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         height="24px"
         viewBox="0 -960 960 960"
         width="24px"
         fill="#1f1f1f"
      >
         <path d="M720-400v-120H600v-80h120v-120h80v120h120v80H800v120h-80Zm-360-80q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM40-160v-112q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v112H40Zm80-80h480v-32q0-11-5.5-20T580-306q-54-27-109-40.5T360-360q-56 0-111 13.5T140-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T440-640q0-33-23.5-56.5T360-720q-33 0-56.5 23.5T280-640q0 33 23.5 56.5T360-560Zm0-80Zm0 400Z" />
      </svg>
   );
};

export const Icon_Microphone: React.FC<IconProps> = ({ className, fill }) => {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         height="24px"
         viewBox="0 -960 960 960"
         width="24px"
         fill="#1f1f1f"
      >
         <path d="M480-400q-50 0-85-35t-35-85v-240q0-50 35-85t85-35q50 0 85 35t35 85v240q0 50-35 85t-85 35Zm0-240Zm-40 520v-123q-104-14-172-93t-68-184h80q0 83 58.5 141.5T480-320q83 0 141.5-58.5T680-520h80q0 105-68 184t-172 93v123h-80Zm40-360q17 0 28.5-11.5T520-520v-240q0-17-11.5-28.5T480-800q-17 0-28.5 11.5T440-760v240q0 17 11.5 28.5T480-480Z" />
      </svg>
   );
};

export const Icon_SplitCall: React.FC<IconProps> = ({ className, fill }) => {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         height="24px"
         viewBox="0 -960 960 960"
         width="24px"
         fill="#1f1f1f"
      >
         <path d="M440-160v-304L240-664v104h-80v-240h240v80H296l224 224v336h-80Zm154-376-58-58 128-126H560v-80h240v240h-80v-104L594-536Z" />
      </svg>
   );
};

export const Icon_ManageUsers: React.FC<IconProps> = ({ className, fill }) => {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         height="24px"
         viewBox="0 -960 960 960"
         width="24px"
         fill="#1f1f1f"
      >
         <path d="M0-240v-63q0-43 44-70t116-27q13 0 25 .5t23 2.5q-14 21-21 44t-7 48v65H0Zm240 0v-65q0-32 17.5-58.5T307-410q32-20 76.5-30t96.5-10q53 0 97.5 10t76.5 30q32 20 49 46.5t17 58.5v65H240Zm540 0v-65q0-26-6.5-49T754-397q11-2 22.5-2.5t23.5-.5q72 0 116 26.5t44 70.5v63H780Zm-455-80h311q-10-20-55.5-35T480-370q-55 0-100.5 15T325-320ZM160-440q-33 0-56.5-23.5T80-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T160-440Zm640 0q-33 0-56.5-23.5T720-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T800-440Zm-320-40q-50 0-85-35t-35-85q0-51 35-85.5t85-34.5q51 0 85.5 34.5T600-600q0 50-34.5 85T480-480Zm0-80q17 0 28.5-11.5T520-600q0-17-11.5-28.5T480-640q-17 0-28.5 11.5T440-600q0 17 11.5 28.5T480-560Zm1 240Zm-1-280Z" />
      </svg>
   );
};

export const Icon_MoreActions: React.FC<IconProps> = ({ className, fill }) => {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         height="24px"
         viewBox="0 -960 960 960"
         width="24px"
         fill={fill}
      >
         <path d="M240-400q-33 0-56.5-23.5T160-480q0-33 23.5-56.5T240-560q33 0 56.5 23.5T320-480q0 33-23.5 56.5T240-400Zm240 0q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm240 0q-33 0-56.5-23.5T640-480q0-33 23.5-56.5T720-560q33 0 56.5 23.5T800-480q0 33-23.5 56.5T720-400Z" />
      </svg>
   );
};

export const Icon_ContinueCall: React.FC<IconProps> = ({ className, fill }) => {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         height="28px"
         viewBox="0 -960 960 960"
         width="28px"
         fill={"#fff"}
      >
         <path d="M320-200v-560l440 280-440 280Zm80-280Zm0 134 210-134-210-134v268Z" />
      </svg>
   );
};

export const Icon_ListSummariesLeftArrow: React.FC<IconProps> = ({
   className,
   style,
   onClick,
   fill,
}) => {
   return (
      <svg
         className={className}
         style={style}
         onClick={onClick}
         width="15"
         height="27"
         viewBox="0 0 15 27"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <path
            d="M5.45449 13.4999L15 24L12.2727 27L0 13.4999L12.2727 0L15 2.99998L5.45449 13.4999Z"
            fill={fill || "#0C5B3A"}
         />
      </svg>
   );
};

export const Icon_ListSummariesRightArrow: React.FC<IconProps> = ({
   className,
   style,
   onClick,
   fill,
}) => {
   return (
      <svg
         className={className}
         style={style}
         onClick={onClick}
         width="15"
         height="27"
         viewBox="0 0 15 27"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <path
            d="M9.54551 13.5001L0 3L2.72728 0L15 13.5001L2.72728 27L0 24L9.54551 13.5001Z"
            fill={fill || "#0C5B3A"}
         />
      </svg>
   );
};

export const Icon_CommentWithDots: React.FC<IconProps> = ({ className, fill }) => {
   return (
      <svg
         width="15"
         height="15"
         viewBox="0 0 15 15"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <path
            d="M3.75 5.99999C3.75 5.58578 4.08579 5.24999 4.5 5.24999H4.5075C4.92171 5.24999 5.2575 5.58578 5.2575 5.99999C5.2575 6.4142 4.92171 6.74999 4.5075 6.74999H4.5C4.08579 6.74999 3.75 6.4142 3.75 5.99999Z"
            fill={fill}
         />
         <path
            d="M6.75 5.99999C6.75 5.58578 7.08579 5.24999 7.5 5.24999H7.5075C7.92171 5.24999 8.2575 5.58578 8.2575 5.99999C8.2575 6.4142 7.92171 6.74999 7.5075 6.74999H7.5C7.08579 6.74999 6.75 6.4142 6.75 5.99999Z"
            fill={fill}
         />
         <path
            d="M9.75 5.99999C9.75 5.58578 10.0858 5.24999 10.5 5.24999H10.5075C10.9217 5.24999 11.2575 5.58578 11.2575 5.99999C11.2575 6.4142 10.9217 6.74999 10.5075 6.74999H10.5C10.0858 6.74999 9.75 6.4142 9.75 5.99999Z"
            fill={fill}
         />
         <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.65901 0.659009C1.08097 0.237052 1.65326 0 2.25 0H12.75C13.3467 0 13.919 0.237053 14.341 0.659009C14.7629 1.08096 15 1.65326 15 2.25V9.74999C15 10.3467 14.7629 10.919 14.341 11.341C13.919 11.7629 13.3467 12 12.75 12H4.06066L1.28033 14.7803C1.06583 14.9948 0.743243 15.059 0.462987 14.9429C0.182732 14.8268 0 14.5533 0 14.25V2.25C0 1.65326 0.237053 1.08097 0.65901 0.659009ZM2.25 1.5C2.05109 1.5 1.86032 1.57902 1.71967 1.71967C1.57902 1.86032 1.5 2.05108 1.5 2.25V12.4393L3.21967 10.7197C3.36032 10.579 3.55109 10.5 3.75 10.5H12.75C12.9489 10.5 13.1397 10.421 13.2803 10.2803C13.421 10.1397 13.5 9.9489 13.5 9.74999V2.25C13.5 2.05108 13.421 1.86032 13.2803 1.71967C13.1397 1.57902 12.9489 1.5 12.75 1.5H2.25Z"
            fill={fill}
         />
      </svg>
   );
};

export const Icon_CasePlanned: React.FC<IconProps> = ({ className, fill }) => {
   return (
      <svg
         width="16"
         height="16"
         viewBox="0 0 16 16"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <path
            d="M5.3824 0V1.53289H9.9926V0H11.5255V1.53289H14.6028C15.0292 1.53289 15.375 1.87865 15.375 2.3051V14.6028C15.375 15.0292 15.0292 15.375 14.6028 15.375H0.772208C0.345765 15.375 0 15.0292 0 14.6028V2.3051C0 1.87865 0.345765 1.53289 0.772208 1.53289H3.84951V0H5.3824ZM13.8306 7.6875H1.53289V13.8306H13.8306V7.6875ZM6.91529 9.22039V12.2977H3.07731V9.22039H6.91529ZM3.83799 3.07731H1.53289V6.15461H13.8306V3.07731H11.5255V4.61019H9.9926V3.07731H5.3824V4.61019H3.84951V3.07731H3.83799Z"
            fill={fill}
         />
      </svg>
   );
};

export const Icon_Placefinder: React.FC<IconProps> = ({ className, fill = "none" }) => {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         width="32"
         height="32"
         viewBox="0 0 24 24"
         className={className}
      >
         <g fill={fill} stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
            <path stroke-width="2" d="M12.005 11h.008M8.01 11h.009" />
            <path
               stroke-width="1.5"
               d="M12 3c-1.48 0-2.905.03-4.244.088c-2.44.105-3.66.157-4.626 1.13c-.965.972-1.007 2.159-1.09 4.532a64 64 0 0 0 0 4.5c.083 2.373.125 3.56 1.09 4.532c.965.973 2.186 1.025 4.626 1.13l.244.01v2.348a.73.73 0 0 0 1.205.554l2.18-1.869c.547-.47.821-.704 1.147-.828s.696-.131 1.437-.145q1.171-.023 2.275-.07c2.44-.105 3.66-.157 4.626-1.13c.965-.972 1.007-2.159 1.09-4.532c.015-.41.034-.826.04-1.25"
            />
            <path stroke-width="1.5" d="m22 9l-1.625-1.625M21 5a3 3 0 1 0-6 0a3 3 0 0 0 6 0" />
         </g>
      </svg>
   );
};

export const Icon_CallUser: React.FC<IconProps> = ({ className, fill }) => {
   return (
      <svg
         width="32"
         height="32"
         viewBox="0 0 32 32"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M26.6924 22.8899C26.4777 23.4116 26.3233 24.2402 25.3386 25.2462C25.3084 25.2834 25.2641 25.3278 25.2197 25.3722C22.7658 27.826 17.8617 27.8278 10.5019 20.4644C3.14207 13.1011 3.14384 8.19691 5.59593 5.74305C5.64206 5.69692 5.68464 5.65434 5.72368 5.6224C6.72793 4.63589 7.55476 4.4833 8.07818 4.26683C9.10372 4.07876 10.0033 3.78245 10.6864 5.70934L11.9462 9.05745C12.2833 10.0404 12.1165 10.7022 11.2719 11.0819L10.1506 11.6497C9.47633 12.0028 9.62359 13.1916 9.86135 13.7505C10.6917 15.3474 11.2613 16.3161 12.954 18.0088V18.0159L12.9557 18.0124C14.6484 19.7068 15.6172 20.2764 17.2141 21.1067C17.773 21.3427 18.96 21.4918 19.3131 20.8175L19.8808 19.6944C20.2605 18.8498 20.9223 18.683 21.9035 19.0202L25.2516 20.2799C27.2105 21.034 26.8822 21.8644 26.6924 22.8881V22.8899Z"
            fill="white"
         />
      </svg>
   );
};
